<template>
  <div class="job-detail-info">
    <PaletteButton
      v-if="isPreview"
      class="palette-button"
      @changeDevice="handleChangeDevice"
      @closePreview="handleClosePreview"
    />
    <div v-if="isPreview" class="preview-mask"></div>
    <!-- if is_show_henkel_protocol start -->
    <div v-if="is_show_henkel_protocol && theJobCanShow" v-show="henkelAgm2PopupShow" ref="henkelAgm2Popup" id="henkel-agm2-popup">
      <div id="henkel-agm2-popup-mask"></div>
      <div class="popBox">
        <div class="top">
          <img class="henkel-logo" :src="company.logo ? $DjangoBaseUrl(company.logo) : $DjangoStaticUrl(`images_en/default_company.jpg`)" alt="">
          <a class="close-btn" @click="henkelAgm2PopupHide"></a>
        </div>
        <div class="content">
          <div class="content-text" ref="henkelAgm2PopupContentText">
            <div class="title">{{ HENKEL_PROTOCOL.title }}</div>
            <div class="main-text">
              <p>{{ HENKEL_PROTOCOL.textP1 }}</p>
              <p>{{ HENKEL_PROTOCOL.textP2 }}</p>
              <p>{{ HENKEL_PROTOCOL.textP3 }}</p>
              <p v-html="HENKEL_PROTOCOL.textP4"></p>
            </div>
          </div>
          <div class="scroll-button">
            <div class="icon icomoon-arrow-up" @click="henkelScrollUp"></div>
            <div class="icon icomoon-arrow-down" @click="henkelScrollDown"></div>
          </div>
        </div>
        <div class="bottom">
          <a id="disagree-second-agreement" @click="henkelAgreementPopBoxEvent($event,0)">
            <div class="btn floatL">
              <div class="btn-top">{{ $t('jobDetail.disagree') }}</div>
              <div class="btn-bottom">{{ $t('jobDetail.andContinue') }}</div>
            </div>
          </a>
          <a id="agree-second-agreement" @click="henkelAgreementPopBoxEvent($event,1)">
            <div class="btn floatR">
              <div class="btn-top">{{ $t('jobDetail.agree')}}</div>
              <div class="btn-bottom">{{ $t('jobDetail.andContinue') }}</div>
            </div>
          </a>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <!-- if is_show_henkel_protocol end -->

    <!-- 弹窗协议 -->
    <PopupPolicyDialog
      v-if="theJobCanShow"
      isMobile
      :show.sync="showStatement"
      :companyPolicyInfo="companyPolicyInfo"
      :isAgreeSystemPolicy="personalAgreementStatus?.is_agreed_system_policy"
      :showSystemPolicy="!personalAgreementStatus?.is_agreed_system_policy"
      :onlySystemPolicy="need_statement_2"
      @save="handleAgreeBtnClick"
      @cancel="handleCancelBtnClick"
    ></PopupPolicyDialog>
    <!-- if need_statement end -->

    <!-- apply internal job -->
    <ApplyInternalJob :company="company" :rootCompanyId="job.root_company_id" :hasReferralShare="has_referral_share" v-show="showInternalJob" />
    <!-- apply internal job end-->

    <!-- job expired -->
    <JobExpired :company="company" v-show="showJobExpired" />
    <!-- job expired end-->

    <div class="page-wrapper js-wechat-share-page job-detail-wrapper" v-if="(showPageContent && theJobCanShow || isPreview)" :class="(jobToShowReferral || submit_referral) && 'referral-wrapper'">
      <div class="job-content">
        <!-- navBar start -->
        <div v-if="false" class="no-custom-landing-page-navbar">
          <a class="back-to-container" @click="onBackBtnIconClick">
            <div class="back-to"></div>
          </a>
          <div class="nav-bar">
            <NavBar
              :account="account"
              :company="company"
              :showNavBar="showNavBar"
              :showHolder="true"
              :isHiddenHome="true"
              :currentPage="6"
              @afterPopupClosed="showNavBar=false"
            ></NavBar>
          </div>
          <div class="share-link-container" ref="shareLinkContainer" @click="shareIconClick">
            <div class="share-link-btn"></div>
          </div>
          <div class="company">
            <router-link :to="companyBrandingUrl">
              <img v-if="company.logo" class="company-img" :src="$DjangoBaseUrl(company.logo)" ref="jobContentCompanyImg"/>
              <img v-else class="company-img" :src="$DjangoStaticUrl(`images_en/default_company.jpg`)" ref="jobContentCompanyImg"/>
            </router-link>
            <div class="company-info">
              <div class="job-title job-title-name">
                {{ job.i18n_name || getI18nPropertyValue(jobDetailInfo, 'cn_title', 'title') }}
              </div>
              <div class="company-name">
                {{ languageCode === 'en' ? company.name : company.cn_name }}
              </div>
              <div class="company-date">{{job.updated_time|formatDate}}</div>
            </div>
            <div v-if='!company.is_overseas_company' class="map-icon-container" @click="onMapBtnIconClick">
              <span class="map-icon"></span>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="custom-header" :class="isPreview && 'is-preview'">
            <div class="header-title">
              <div class="left">
                <div id="menu-icon" class="menu-icon character-image icomoon-menu" @click="onMenuIconClick"></div>
                </div>
              <span class="company-name center">{{ getI18nPropertyValue(company, 'cn_name', 'name') }}</span>
              <div @click="referralShareIconClick" class="icomoon-share share-link-icon"></div>
            </div>
            <div class="header-main">
              <div class="logo" :style="{backgroundImage: 'url('+ $DjangoBaseUrl(isPreview ? company.logo : company_logo)+')'}">
              </div>
              <div class="message">
                <p class="job-name job-title-name">{{ job.i18n_name || getI18nPropertyValue(jobDetailInfo, 'cn_title', 'title') }}</p>
                <p class="company-name">{{ getI18nPropertyValue(company, 'cn_name', 'name') }}</p>
                <p class="date">{{ updateTime ? updateTime : job.updated_time|formatDate }}</p>
              </div>
            </div>
            <div class="header-menu">
              <template v-if='isPreview ? !hasCustomMobileLandingPage2 : !has_custom_mobile_landing_page_2'>
                <div v-if="has_custom_mobile_landing_page || hasCustomMobileLandingPage" class="about-us col-2">
                  <router-link :to="companyBrandingUrl">{{ isPreview ? aboutUsPreview : about_us }}</router-link>
                </div>
                <div class="col-2 view-jobs" :class="!has_custom_mobile_landing_page && !hasCustomMobileLandingPage && 'full-line'">
                  <a class="company-customized" href="javascript:void(0);" @click="backJobList">{{ $t('jobDetail.viewJobs') }}</a>
                </div>
              </template>
              <template v-else>
                <div v-if="has_custom_mobile_landing_page || hasCustomMobileLandingPage" class="col-3">
                  <router-link :to="companyBrandingUrl">{{ isPreview ? aboutUsPreview : about_us }}</router-link>
                </div>
                <div class="col-3">
                  <router-link :to="companyLandingUrl">{{ isPreview ? groupName : group }}</router-link>
                </div>
                <div class="col-3 view-jobs" :class="!has_custom_mobile_landing_page && !hasCustomMobileLandingPage && 'full-line'">
                  <a class="company-customized" @click="backJobList">{{ $t('jobDetail.viewJobs') }}</a>
                </div>
              </template>
            </div>
          </div>
          <MobilePersonalMenu
            v-model="showNavBar"
            :company="company"
            :hideReferralProgram="hideReferralProgram"
            :hasLogin="hasLogin"
            :isEmployeeAccount="isEmployeeAccount"
            :hideCompanyMenu="!has_custom_mobile_landing_page && !hasCustomMobileLandingPage"
          />
        </div>
        <!-- navBar end -->

        <!-- jobDetail-infoMation start -->
        <div id="job-detail-information-contanier" ref="jobDetailInformationContanier">
          <div class="job-intro" :class="webpage_item && 'has_webpage_item'">
            <div class="company-survey-container" :class="!displayJobFieldInfoList?.length && 'no-job-custom-field'">
              <a v-if="show_survey_entrance && !isPreview" class="company-survey-entrance" @click="onSurveyEntranceClick">
                <span v-if="has_answered" class="iconfont iconcandidatesurvey-24 company-customized"></span>
                <span v-else class="iconfont iconcandidatesurvey-23 shake-bell"></span>
              </a>
            </div>
            <div class="job-field">
              <div v-for="(item, index) in displayJobFieldInfoList" class="field-item" :key="index">
                <label class="label">{{ item.label || $t(item.labelI18nKey) }}</label>
                <span class="value">{{ item.value || $t(item.valueI18nKey) }}</span>
              </div>
            </div>
            <div class="job_location">
              <div v-if='!company.is_overseas_company' class="location" @click="onMapBtnIconClick">
                <span class="icomoon-location map-icon-customed"></span>
              </div>
              <label class="label">{{ $t('jobDetail.jobLocation') }}</label>
              <div ref="loadingIcon" class="loading-icon" v-show="showLoadingIcon"></div>
              <div class="job-location-field">
                <ul class="locations">
                  <li v-for="(loc, index) in jobLocationList" :key="index"
                    :class="jobLocationList.length > 1 ? `location${index+1} list-style-decimal` : `location${index+1}`"
                    :data-index="jobLocationList.length > 1 && index+1"
                    :data-id="loc.id"
                    :data-lng="loc.longitude"
                    :data-lat="loc.latitude">
                    <span class="loc-name">
                      {{ getI18nPropertyValue(loc.city, 'cn_name', 'name') }}{{ loc.address && ('-' + loc.address) }}
                    </span>
                  </li>
                </ul>
              </div>
              <span ref="showAllLocations" @click="viewMoreLocationEvent" class="all-locations" :class="jobLocationList.length <= 4 && 'hide'">
                <span class="fold-icon"></span>
              </span>
            </div>
          </div>
          <div v-if="webpage_item && webpage_item.length" class="responsibility-request preview-container" id="group-container">
            <ContainerTemplate
              :hasCustomize="jd_customize"
              :webpageItem="webpage_item"
              :languageCode="languageCode"
              :job="job"
              :headerItem="customized_header"
              :footerItem="customized_footer"
            ></ContainerTemplate>
          </div>
          <div v-else class="responsibility-request no-item" id="group-container">
            <ContainerTemplate
              v-if="jd_customize && customized_header"
              :hasCustomize='false'
              :webpageItem="customized_header"
              :languageCode="languageCode"
              :job="job"
            ></ContainerTemplate>
            <div class="preview-group-plane job_des">
              <div class="preview-group">
                <p>{{ job.i18n_name || getI18nPropertyValue(job, 'cn_title', 'title') }}</p>
                <span v-html="getI18nPropertyValue(job, 'cn_description', 'description')"></span>
                <img v-if="is_in_root_company_jd_customized_array" class="customized-img" :src="$DjangoStaticUrl(`image/marketing/jd_customized/${job.root_company_id}-mob-img.png`)" />
              </div>
            </div>
            <ContainerTemplate
              v-if="jd_customize && customized_footer"
              :hasCustomize='false'
              :webpageItem="customized_footer"
              :languageCode="languageCode"
              :job="job">
            </ContainerTemplate>
          </div>
          <p v-if="!hasHiddenPoweredWord" class="powered-by" :class="job.is_in_group && 'group-job-padding'">
            <span>Powered by ajinga.com</span>
          </p>
        </div>
      </div>
      <!-- jobDetail-infoMation end -->

      <!-- jobDetail-mapContainer start -->
      <el-collapse-transition>
        <div v-show="showMapContainer" class='jd-map-container' ref="jdMapContainer">
          <div v-rect-loading="mapLoading" id="job-detail-map-container">
            <div class="icon-close" @click="onBackBtnIconClick"></div>
            <div ref="mapContainerTest" id="map-container"></div>
            <div class="job_location job-location-field" ref="mapjobLocations">
              <ul class="locations" ref="locationList">
                <li v-for="(loc, index) in jobLocationList" :key="index"
                  :class="jobLocationList.length > 1 ? `location${index+1} list-style-decimal` : `location${index+1}`"
                  :data-index="jobLocationList.length > 1 && index+1"
                  @click="loccationClick($event,loc,index+1)">
                  <span class="loc-name">
                    {{ getI18nPropertyValue(loc.city, 'cn_name', 'name') }}{{ loc.address && ('-' + loc.address) }}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </el-collapse-transition>
      <!-- jobDetail-mapContainer end -->

      <!-- jobDetail rewards rules start -->
      <div v-if="job_detail_has_rewards_rules" v-show="reviewPopShow" class="reviewPop view-rules-popup" id="view-rules-popup">
        <div id="Overlay" class="overlayBg"></div>
        <div v-if="customization_rewards_rules.mode == 'default'">
          <div class="popDiv">
            <div class="popBox">
              <a class="close-btn" @click="reviewPopHide">X</a>
              <img :src="job.company.logo && $DjangoBaseUrl(job.company.logo)" class="company-img">
              <h1>{{ customization_rewards_rules.dialog_title }}</h1>
              <img :src="$DjangoBaseUrl(customization_rewards_rules.dialog_img_mobile)">
            </div>
          </div>
        </div>

        <div v-if="customization_rewards_rules.mode == 'scrolling'" class="container">
          <div class="popDiv custom-popDiv">
            <div class="popBox custom-popBox">
              <a class="close-btn" @click="reviewPopHide">X</a>
              <img :src="job.company.logo && $DjangoBaseUrl(job.company.logo)" class="company-img">
              <h1>{{ customization_rewards_rules.dialog_title }}</h1>
              <div class="container">
                <div class="l">
                  <div class="head" :style="'background: url(' + $DjangoBaseUrl(customization_rewards_rules.dialog_img_mobile) + ') no-repeat;background-size: cover;'"></div>
                  <div class="main" :style="'background: url(' + $DjangoBaseUrl(customization_rewards_rules.dialog_img_mobile) + ') no-repeat 0 -60px;background-size: cover;'" ref="jobDetailRewardsMain"></div>
                </div>
                <div class="r">
                  <div class="up btn disable" @click="showCustomRewardsRuleUpClick" ref="showCustomRewardsRuleUp">
                    <span class="icomoon-arrow-up"></span>
                  </div>
                  <div class="down btn" @click="showCustomRewardsRuleDownClick" ref="showCustomRewardsRuleDown">
                    <span class="icomoon-arrow-down"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="customization_rewards_rules.mode == 'full_image'">
          <div class="popDiv custom-popDiv">
            <div class="popBox custom-popBox">
              <a class="close-btn" @click="reviewPopHide">X</a>
              <div class="container full-image">
                <div class="l">
                  <div class="main" :style="'background: url(' + $DjangoBaseUrl(customization_rewards_rules.dialog_img_mobile) + ') no-repeat 0 0px;background-size: cover;'" ref="jobDetailRewardsMain"></div>
                </div>
                <div class="r">
                  <div class="up btn disable" @click="showCustomRewardsRuleUpClick" ref="showCustomRewardsRuleUp">
                    <span class="icomoon-arrow-up"></span>
                  </div>
                  <div class="down btn" @click="showCustomRewardsRuleDownClick" ref="showCustomRewardsRuleDown">
                    <span class="icomoon-arrow-down"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="company.has_custom_referral_rewards && customization_rewards_rules.mode == 'custom_image'">
          <div class="popDiv custom-popDiv custom-image-popDiv">
            <div class="popBox custom-popBox custom-image-popbox">
              <img :src="$DjangoBaseUrl(customization_rewards_rules.dialog_img_mobile)">
              <i class="el-icon-circle-close custom-image-icon" @click="reviewPopHide"></i>
            </div>
          </div>
        </div>
      </div>
      <!-- jobDetail rewards rules end -->

      <!-- show_apply | jobToShowReferral start -->
      <template v-if="initStatus.applyStatus && initStatus.referralSetting">
        <div v-if="show_apply || jobToShowReferral" class="btn-group btn-group-next" ref="applybtnGroup">
          <template v-if="show_apply && !revoke_agreement_applicant">
            <!-- <div v-if="is_show_henkel_protocol && !has_apply" class="agree">
              <input ref="henkelAgm1Check" id="henkel-agm1-check" type="checkbox" v-model="is_agreed_company_agreement">
              <label class="checkbox" for="henkel-agm1-check" :class="is_agreed_company_agreement && 'checked'"></label>
              <label for="henkel-agm1-check">
                {{ $t('jobDetail.henkel.iAgreeHnkel') }}
                <a id="hen-agm1" :href="hen_agm1" target="_blank">
                {{ $t('jobDetail.henkel.declarationOfConsentPersonalData') }}
                </a>
              </label>
              <div id="tos_check_error" class="error-text" v-show="tosCheckErrorShow">
                {{ $t('jobDetail.henkel.pleaseCheckHenkelTerms') }}
              </div>
            </div> -->
            <div v-if="need_statement_2" class="agree" :style="`display:${!has_apply || can_reapply ? 'block' : 'none'}`">
              <div class="company-policy-content" v-html="companyPolicyInfo.html_content"></div>
              <el-checkbox v-model="agreePolicy" class="company-policy-checkbox">
                <div class="company-policy-content" v-html="companyPolicyInfo.link[0].i18nContent"></div>
              </el-checkbox>
              <div id="common_tos_check_error" ref="commonTosCheckError" class="error-text hide">
                {{ $t('jobDetail.commonTosCheck.pleaseAgreeToTheTermsToContinue') }}
              </div>
            </div>
            <div v-if="job.is_in_group" class="btn-inner single-job-group-tip" ref="singleJobGroupTip">
              {{ $t('jobDetail.fordApplyJobTipMsg') }}
            </div>
            <template v-if='has_apply'>
              <div v-if="can_reapply" class="btn-inner">
                <a id="apply-directly" ref="applyDirectly" @click="applyDirectlyNeedStatement" class="submit-btn" :class="[need_statement && 'need-statement' , need_statement_2 && 'need-statement-2']">
                  <p class="btn1">{{ $t('jobDetail.reapply') }}</p>
                </a>
              </div>
              <div v-else-if="finish_apply" class="btn-inner">
                <a id="apply-directly" ref="applyDirectly" class="submit-btn disabled">
                  <p class="btn1">{{ $t('jobDetail.applied') }}</p>
                </a>
              </div>
              <div v-else class="btn-inner">
                <a id="apply-directly" ref="applyDirectly" @click="applyDirectlyNeedStatement" class="submit-btn" :class="[need_statement && 'need-statement' , need_statement_2 && 'need-statement-2']">
                  <p class="btn1">{{ $t('jobDetail.continueFinishApply') }}</p>
                </a>
              </div>
            </template>
            <template v-else-if="!cant_applied">
              <div class="btn-inner">
                <a id="apply-directly" ref="applyDirectly" @click="applyDirectlyNeedStatement" :class="[need_statement && 'need-statement' , need_statement_2 && 'need-statement-2']" class="submit-btn">
                  <p class="btn1">{{ $t('jobDetail.apply') }}</p>
                </a>
              </div>
            </template>
          </template>
          <template v-if="jobToShowReferral">
            <div v-if="(is_employee_of_company && ref_steps_setting.employee_real_budget) || ref_steps_setting.non_employee_real_budget" class="btn-inner">
              <div id="earn-up-btn" @click="showReferralTipDialog" :class="is_employee_of_company && 'employee-earn-btn'">
                <p class="btn1" :style="'line-height: 30px;'">
                  <template v-if="rewardContentShowBanlance">
                    {{ custom_referral_title ? $t('jobDetail.btn.customReferralJobRewards') : $t('jobDetail.btn.referJobForRewards') }}
                  </template>
                  <template v-else>{{ rewardContent }}</template>
                </p>
              </div>
            </div>
          </template>
        </div>
      </template>
      <template v-else>
        <div v-if="show_apply" class="btn-group btn-group-next loading-apply-status">
          <div class="btn-inner">
            <a id="apply-directly" class="submit-btn">
              <p class="btn1">{{ $t('jobDetail.apply') }}</p>
            </a>
          </div>
          <RectLoading v-if="!isPreview"/>
        </div>
      </template>
      <!-- show_apply | jobToShowReferral end -->

      <!-- referral_rewards_info start -->
      <div id="referral-rewards-info" v-show="popTipBottomInfoShow" class="pop-tip-bottom">
        <div class="pop-tip-bottom-inner">
          <template v-if="hasRefStepsSetting">
            <p class="rewards-title">
              {{ is_fosun_company ? $t('jobDetail.welcomeToRecommend') : $t('jobDetail.referralRewards') }}
            </p>
            <ReferralInfoList
              :isFosunCompany="is_fosun_company"
              :isCompanyEmployee="is_employee_of_company"
              :hasCustomReferralWord="has_referral_word_customized"
              :usePointsReplaceOthers="isHiddenRewards || isUsePointReplacePayroll"
              :isADPCompany="isADPCompany"
              :isCoachCompany="isCoachCompany"
              :stepSetting="ref_steps_setting"/>
            <div v-if="job_detail_has_rewards_rules">
              <p class="referral-tip-message">{{ customization_rewards_rules.tips }}</p>
              <p class="view_referral_rules" @click="showRewardsRule">{{ $t('jobDetail.rewardsClick') }}</p>
              <!-- <p class="view_referral_rules" @click="showRewardsRule">{{ customization_rewards_rules.click_label }}</p> -->
            </div>
          </template>
          <div class="btn-inner">
            <div v-if="account && account.id" id="earn-rewards-btn" @click="onEarnRewardsNowClick" class="earn_rewards_btn_login">
                <a>
                  <p class="btn">{{ $t('jobDetail.next') }}</p>
                </a>
            </div>
            <template v-else>
              <div v-if="is_lite_referral" id="earn-rewards-btn">
                <a v-if="wechat_login" :href="quickReferralBindWeChatUrl">
                  <p class="btn">{{ $t('jobDetail.next') }}</p>
                </a>
                <a v-else :href="quickReferralUrl">
                  <p class="btn">{{ $t('jobDetail.next') }}</p>
                </a>
              </div>
              <div v-else id="referral-rewards-confirm">
                <a class="btn btn-yes" @click="handleReferralRewardConfirm($event, false)">
                  {{ $t('jobDetail.yes') }}
                </a>
                <div class="confirm-message-div">
                  {{ $t('jobDetail.areYouAnEmployee', { company: has_referral_share ? company.root_company.i18n_name : company.i18n_name}) }}
                </div>
                <a v-if="wechat_login" :href="quickReferralBindWeChatUrl" class="btn btn-no">{{ $t('jobDetail.no') }}</a>
                <a v-else :href="quickReferralUrl" class="btn btn-no">{{ $t('jobDetail.no') }}</a>
              </div>
            </template>
          </div>
          <div id="close-btn" @click="commonCloseClick" class="close">&times;</div>
        </div>
      </div>
      <!-- referral_rewards_info end -->

      <!-- referral_submint_info start -->
      <div  id="referral-submit-info" v-show="popTipBottomSubmitShow" class="pop-tip-bottom" :class="has_color_customization && 'company-custom'" ref="referralSubmitInfo">
        <div class="pop-tip-bottom-inner">
          <template v-if="hasRefStepsSetting">
            <p class="rewards-title">
              {{ is_fosun_company ? $t('jobDetail.welcomeToRecommend') : $t('jobDetail.referralRewards') }}
            </p>
            <ReferralInfoList
              :isFosunCompany="is_fosun_company"
              :isCompanyEmployee="is_employee_of_company"
              :hasCustomReferralWord="has_referral_word_customized"
              :usePointsReplaceOthers="isHiddenRewards || isUsePointReplacePayroll"
              :isADPCompany="isADPCompany"
              :isCoachCompany="isCoachCompany"
              :stepSetting="ref_steps_setting"/>
            <div v-if="job_detail_has_rewards_rules">
              <p class="referral-tip-message">{{ customization_rewards_rules.tips }}</p>
              <p class="view_referral_rules" @click="showRewardsRule">{{ $t('jobDetail.rewardsClick') }}</p>
              <!-- <p class="view_referral_rules" @click="showRewardsRule">{{ customization_rewards_rules.click_label }}</p> -->
            </div>
          </template>
          <div class="btn-inner" :style="!hasRefStepsSetting && 'border: none;'">
            <div v-if="account&&account.id" id="referral-share-confirm">
              <a v-if="showReferralSubmit" class="submit-href btn btn-yes" @click="submitResume" :class="languageCode === 'en' ? 'en' : 'zh-cn'">
                <div class="submit-info" :style="languageCode === 'en' && 'padding-top:3px;'">
                  <template v-if="languageCode !== 'en'">
                    <span class="submit-info-span-zh">{{ $t('jobDetail.submit') }}</span>
                    <div class="submit-info-detail jd-submit-padding">{{ $t('jobDetail.yourReferral') }}</div>
                  </template>
                  <div v-else>
                    <span class="submit-info-span">{{ $t('jobDetail.submit') }}</span>
                    <span class="submit-info-detail jd-submit-margin-top">{{ $t('jobDetail.yourReferral') }}</span>
                    <span class="submit-info-detail">{{ $t('jobDetail.toHR') }}</span>
                  </div>
                </div>
              </a>
              <div v-if="showReferralSubmit" class="confirm-message-div jd-or-width">
                {{ $t('jobDetail.or') }}
              </div>
              <a id="submit-share-btn" @click="submitShareEvent" class="btn btn-no" :class="[languageCode === 'en' ? 'en' : 'zh-cn', !showReferralSubmit && 'hidden-submit']">
                <div class="submit-info" :style="languageCode === 'en' && 'padding-top:3px;'">
                  <template v-if="languageCode !== 'en'">
                    <span class="submit-info-span-zh">{{ $t('jobDetail.share') }}</span>
                    <div class="submit-info-detail jd-submit-padding">{{ $t('jobDetail.toAFriend') }}</div>
                  </template>
                  <div v-else>
                    <span class="submit-info-span">{{ $t('jobDetail.share') }}</span>
                    <span class="submit-info-detail jd-submit-margin-top">{{ $t('jobDetail.toAFriend') }}</span>
                    <span class="submit-info-detail">via social media</span>
                  </div>
                </div>
              </a>
            </div>
            <template v-else>
              <div id="referral-rewards-confirm" class="submit-referral-confirm" v-show="submitReferralConfirmShow">
                  <a class="btn btn-yes" @click="handleReferralRewardConfirm($event, true)"> {{ $t('jobDetail.yes') }}</a>
                  <div class="confirm-message-div">
                      {{ $t('jobDetail.areYouAnEmployee', { company: has_referral_share ? company.root_company.i18n_name : company.i18n_name}) }}
                  </div>
                  <template v-if="is_external_job_referral">
                    <a v-if="wechat_login" :href="quickReferralBindWeChatUrl" class="btn btn-no">{{ $t('jobDetail.no') }}</a>
                    <a v-else :href="`${quickReferralUrl}?submit=1`" class="btn btn-no">{{ $t('jobDetail.no') }}</a>
                  </template>
                  <a v-else id="inner-job-btn" @click="innerReferralEvent" class="btn btn-no">{{ $t('jobDetail.no') }}</a>
              </div>
              <div id="referral-share-confirm" class="submit-referral-share-confirm" v-show="submitReferralShareConfirmShow">
                <a v-if="showReferralSubmit" class="submit-href btn btn-yes" @click="submitResume" :class="languageCode === 'en' ? 'en' : 'zh-cn'">
                  <div class="submit-info" :style="languageCode === 'en' && 'padding-top:3px;'">
                    <template v-if="languageCode !== 'en'">
                      <span class="submit-info-span-zh">{{ $t('jobDetail.submit') }}</span>
                      <div class="submit-info-detail jd-submit-padding">{{ $t('jobDetail.yourReferral') }}</div>
                    </template>
                    <div v-else>
                      <span class="submit-info-span">{{ $t('jobDetail.submit') }}</span>
                      <span class="submit-info-detail jd-submit-margin-top">{{ $t('jobDetail.yourReferral') }}</span>
                      <span class="submit-info-detail">{{ $t('jobDetail.toHR') }}</span>
                    </div>
                  </div>
                </a>
                <div v-if="showReferralSubmit" class="confirm-message-div jd-or-width">
                    {{ $t('jobDetail.or') }}
                </div>
                <a id="submit-share-btn" @click="submitShareEvent" class="btn btn-no" :class="[languageCode === 'en' ? 'en' : 'zh-cn', !showReferralSubmit && 'hidden-submit']">
                  <div class="submit-info" :style="languageCode === 'en' && 'padding-top:3px;'">
                    <template v-if="languageCode !== 'en'">
                      <span class="submit-info-span-zh">{{ $t('jobDetail.share') }}</span>
                      <div class="submit-info-detail jd-submit-padding">{{ $t('jobDetail.toAFriend') }}</div>
                    </template>
                    <div v-else>
                      <span class="submit-info-span">{{ $t('jobDetail.share') }}</span>
                      <span class="submit-info-detail jd-submit-margin-top">{{ $t('jobDetail.toAFriend') }}</span>
                      <span class="submit-info-detail">via social media</span>
                    </div>
                  </div>
                </a>
              </div>
            </template>
            <!-- <div v-else id="referral-share-confirm">
              <a class="submit-href btn btn-yes" @click="submitResume" :class="languageCode === 'en' ? 'en' : 'zh-cn'">
                <div class="submit-info" :style="languageCode === 'en' && 'padding-top:3px;'">
                  <template v-if="languageCode !== 'en'">
                    <span class="submit-info-span-zh">{{ $t('jobDetail.submit') }}</span>
                    <div class="submit-info-detail jd-submit-padding">{{ $t('jobDetail.yourReferral') }}</div>
                  </template>
                  <div v-else>
                    <span class="submit-info-span">{{ $t('jobDetail.submit') }}</span>
                    <span class="submit-info-detail jd-submit-margin-top">{{ $t('jobDetail.yourReferral') }}</span>
                    <span class="submit-info-detail">{{ $t('jobDetail.toHR') }}</span>
                  </div>
                </div>
              </a>
              <div class="confirm-message-div jd-or-width">
                  {{ $t('jobDetail.or') }}
              </div>
              <a id="submit-share-btn" @click="submitShareEvent" class="btn btn-no" :class="languageCode === 'en' ? 'en' : 'zh-cn'">
                <div class="submit-info" :style="languageCode === 'en' && 'padding-top:3px;'">
                  <template v-if="languageCode !== 'en'">
                    <span class="submit-info-span-zh">{{ $t('jobDetail.share') }}</span>
                    <div class="submit-info-detail jd-submit-padding">{{ $t('jobDetail.toAFriend') }}</div>
                  </template>
                  <div v-else>
                    <span class="submit-info-span">{{ $t('jobDetail.share') }}</span>
                    <span class="submit-info-detail jd-submit-margin-top">{{ $t('jobDetail.toAFriend') }}</span>
                    <span class="submit-info-detail">via social media</span>
                  </div>
                </div>
              </a>
            </div> -->
          </div>
          <div id="submit-close-btn" @click="commonCloseClick" class="close">&times;</div>
        </div>
      </div>
      <!-- referral_submint_info end -->

      <!-- referral-icon start -->
      <div v-if="!jobToShowReferral && !isInternalJob && hasReferralPermission && showReferralBtn" id="referral-icon" @click="onReferalIconClick" v-show='referralIconShow'>
        <div>
          <img class="referral-img" v-if="languageCode === 'en'" :src="$DjangoStaticUrl(`image/mobile_web/referral-icon-en.png`)"/>
          <img class="referral-img" v-else :src="$DjangoStaticUrl(`image/mobile_web/referral-icon-zh.png`)"/>
        </div>
      </div>
      <!-- referral-icon end -->

      <!-- wechat-popup start -->
      <div id="wechat-popup">
        <div id='mask' v-show="maskShow"></div>

        <div v-if="job.is_in_group" v-show="singleJobGroupPopupShow" id="single-job-group-popup">
          <span class="close-btn" @click="singleJobGroupPopupClose"></span>
          <div class="share-tip-container">
            {{ $t('jobDetail.importantNotice') }}
          </div>
          <div class="share-content">
            <p class="tip">
              {{ $t('jobDetail.fordApplyJobTipMsg1') }}
            </p>
            <p class="tip">
              {{ $t('jobDetail.fordApplyJobTipMsg2') }}
            </p>
            <div class="btn-container">
              <a class="btn back-btn" href="javascript:void(0);" @click="backJobList">{{ $t('jobDetail.viewFullJobList') }}</a>
              <div class="btn continue-btn" @click="singleJobGroupPopupCloseContinue">{{ $t('jobDetail.apply') }}</div>
            </div>
          </div>
        </div>

        <div id="wechat-pointer" @click="wechatPointerClick" v-show="wechatPointerShow">
          <div class="pointer"></div>
        </div>
        <div id="wechat-share-tip" v-show="wechatShareTipShow"></div>
        <div id="qrcode-transition" ref="qrcodeTransition" v-show="qrcodeTransitionShow">
          <span class="close-btn" @click="shareTransitonClose"></span>
          <div class="share-tip-container">
            {{ job.i18n_name }}
          </div>

          <div class="share-content">
            <div class="qrcode-content" v-show="qrcodeContentShow" ref="qrcodeContent"></div>
            <div class="qrcode-alt" v-show="qrcodeAltShow"></div>
          </div>
        </div>

        <div id="referral-transition" v-show="referralTransitionShow" ref="referralTransition">
          <span class="close-btn" @click="closePopupEvent"></span>
          <div class="share-tip-container company">
            <router-link :to="jobCompanyBrandingUrl">
              <img v-if="job.company.logo" :src="$DjangoBaseUrl(job.company.logo)" class="company-img" ref="referralTransitionCompanyImg"/>
              <img v-else class="company-img" :src='$DjangoStaticUrl(`images_en/default_company.jpg`)' ref="referralTransitionCompanyImg"/>
            </router-link>
            <div class="company-info">
              <div class="job-title">
                {{ job.i18n_name }}
              </div>
              <div class="company-name">
                {{ job.company.i18n_name }}
              </div>
            </div>
          </div>

          <div class="share-content">
            <p v-if="jobToShowReferral && !has_referral_word_customized && !isHiddenRewards" class="tip">{{ $t('jobDetail.shareYourPersonallyParm', { balance: jobReferralRewardsTip }) }}</p>
            <p v-else-if="jobToShowReferral && has_referral_word_customized" class="tip">
              {{ $t('jobDetail.shareYourPersonally') }}
            </p>
            <div v-if="hasLogin && company?.root_company.id && !wxUserHasBindRewards && jobToShowReferral && ((is_employee_of_company && ref_steps_setting.employee_real_budget) || ref_steps_setting.non_employee_real_budget)" class="get-rewards">
              <van-button class="get-rewards-btn" @click="handleGetQrCode">{{ $t('personal.referrals.rewards.label.payByWeChatWallet') }}</van-button>
            </div>
            <div v-if="!hiddenReferShare"  class="refer-share-to">
              {{ $t('jobDetail.sendTo') }}
              <div class="referral-share-action">
                <div v-if="!is_in_china" class="oneline">
                  <a class="share-facebook" @click="shareFacebookClick" :class="[referral_share_url && 'referral-share' ,( account&&account.id ) && 'submit-share']" target="_blank" ></a>
                  <a class="share-messenger" @click="shareMessageClick" :class="[referral_share_url && 'referral-share' ,( account&&account.id ) && 'submit-share']" ></a>
                  <a class="share-linkedin" @click="shareLinkedinClick" :class="[referral_share_url && 'referral-share' ,( account&&account.id ) && 'submit-share']" target="_blank" ></a>
                  <a class="share-whatsapp" @click="shareWhatappClick" :class="[referral_share_url && 'referral-share' ,( account&&account.id ) && 'submit-share']" ></a>
                  <a class="share-email copy-btn" @click="shareEmailClick" :class="[referral_share_url && 'referral-share' ,( account&&account.id ) && 'submit-share']"></a>
                </div>

                <div class="oneline">
                  <a class="share-qrcode" @click="shareQrcodeClick" :class="[referral_share_url && 'referral-share' ,( account&&account.id ) && 'submit-share']" target="_blank" ref='shareQrcodeBtn'></a>
                  <a class="share-qq" @click="shareQQClick" :class="[referral_share_url && 'referral-share' ,( account&&account.id ) && 'submit-share']" target="_blank"></a>
                  <a class="share-qzone" @click="shareQzoneClick" :class="[referral_share_url && 'referral-share' ,( account&&account.id ) && 'submit-share']" target="_blank" ></a>
                  <a class="share-sina" @click="shareSinaClick" :class="[referral_share_url && 'referral-share' ,( account&&account.id ) && 'submit-share']" target="_blank" ></a>
                  <a class="share-wechat" @click="shareWechatClick" :class="[referral_share_url && 'referral-share' ,( account&&account.id ) && 'submit-share']"></a>
                </div>

                <div v-if="is_in_china" class="oneline">
                  <a class="share-facebook" @click="shareFacebookClick" :class="[referral_share_url && 'referral-share' ,( account&&account.id ) && 'submit-share']" target="_blank" ></a>
                  <a class="share-messenger" @click="shareMessageClick" :class="[referral_share_url && 'referral-share' ,( account&&account.id ) && 'submit-share']" ></a>
                  <a class="share-linkedin" @click="shareLinkedinClick" :class="[referral_share_url && 'referral-share' ,( account&&account.id ) && 'submit-share']" target="_blank" ></a>
                  <a class="share-whatsapp" @click="shareWhatappClick" :class="[referral_share_url && 'referral-share' ,( account&&account.id ) && 'submit-share']" ></a>
                  <a class="share-email copy-btn" @click="shareEmailClick" :class="[referral_share_url && 'referral-share' ,( account&&account.id) && 'submit-share'] "></a>
                </div>
              </div>
            </div>
            <div v-if="job.root_company_id !== 4753 && !hiddenReferShare" class="learn-more">
              <a :href="$DjangoBaseUrl(`/referral/about-program/?company_id=${company.id || ''}`)"> {{ $t('jobDetail.learnMore') }} ></a>
            </div>
          </div>
          <template v-if="showJobPoster">
            <van-divider v-if="!hiddenReferShare" :style="{ borderColor: '#000', padding: '0 16px', margin: '0'}">{{ $t('jobDetail.or') }}</van-divider>
            <div class="share-job-poster">
              <!-- <div class="poster-tip share-tip-container">{{ $t('jobDetail.shareJobPoster') }}</div> -->
              <div class="poster-tip-container">
                <span class="share-text">{{ $t('jobDetail.tapToShare') }}</span>
                <span class="video-tip" v-show="isGeneratingVideo">{{ $t('jobDetail.videoIsGenerating') }}</span>
              </div>
              <div class="poster-preview">
                <div
                  v-for="(jobPoster, index) in posterListData"
                  class="poster-preview-container"
                  :style="{ width: `${getPosterContainerWidth(jobPoster, posterListData.length) * 100}%` }"
                  :key="index"
                >
                  <div class="image-container" :style="{ 'width': '100%'}">
                    <div v-if="isVideoPoster(jobPoster)" class="icon-video-play">
                      <div></div>
                      <img src="@/assets/image/jobDetail/play.png" @click="onPosterPreviewClick(jobPoster)"/>
                    </div>
                    <div class="image-wrapper">
                      <div class="image-overlay" @click="onPosterPreviewClick(jobPoster)"></div>
                      <img :src="jobPoster.posterShareImg" @click="onPosterPreviewClick(jobPoster)"/>
                    </div>
                  </div>
                  <div class="share-btn" :style="{ 'background-color': company.custom_color || 'red' }" @click="onPosterPreviewClick(jobPoster)">
                    <i class="el-icon-share"></i><span>{{ $t('jobDetail.sharePoster') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="poster-transition" v-if="posterTransitionShow" ref="posterTransition">
          <div class="poster-img">
            <span v-show="!showDownloadTip" class="poster-close-btn" @click="shareTransitonClose">
              <i class="el-icon-circle-close"></i>
            </span>
            <div class="job-poster-content">
              <video
                v-if="isVideoPoster(currentPopPoster)"
                ref="poster-video"
                id="poster-video"
                preload="auto"
                controls
                :style="{ height: getVideoHeight(currentPopPoster), objectFit: 'cover' }"
                :src="currentPopPoster.originVideoSrc"
                :poster="currentPopPoster.posterShareImg"
                @loadedmetadata="onVideoLoaded"
              >
              </video>
              <img v-else :src="posterImgUrl"/>
            </div>
            <van-uploader
              v-if="currentPosterShowType === 'CUSTOM'"
              v-model="newJobPosterImages"
              :accept="currentPopPoster.poster_type === 'video' ? 'video/*' : 'image/*'"
              class="upload-new-poster"
              :preview-image="false"
              :before-read="beforeUploadPoster"
              :after-read="handleUploadPoster"
            >
              <div class="label">{{ $t(`${jobPosterI18nPrefix}.btn.${currentPopPoster.poster_type === 'video' ? 'editVideoJobPoster' : 'editImgJobPoster'}`) }}</div>
            </van-uploader>
          </div>
          <div v-if="!(currentPosterShowType === 'CUSTOM' || currentPosterShowType === 'INSTRUCTIONS')" v-show="saveImgTipShow && !isVideoPoster(currentPopPoster)" class="save-video-tip-pop">
            <div class="save-video-text">{{ $t('jobDetail.longPressToSave') }}</div>
          </div>
          <div
            v-if="!(currentPosterShowType === 'CUSTOM' || currentPosterShowType === 'INSTRUCTIONS')"
            v-show="saveImgTipShow && isVideoPoster(currentPopPoster)"
            class="save-video-tip-pop"
            @click="generatePosterVideo(currentPopPoster)"
          >
            <div v-show="!isGeneratingVideo">
              <div class="download-text">
                {{ $t('jobDetail.downloadNow') }}
                <!-- <span v-if="isiOSWechat" class="iconfont icona-referralFAQ"
                  @click.stop="showiOSWechatDownloadTipByTipButton = true">
                </span> -->
              </div>
              <div class="download-image"><span class="iconfont icondownload"></span></div>
              <div class="save-video-text">{{ $t('jobDetail.saveVideo') }}</div>
            </div>
            <div v-show="isGeneratingVideo">
              <div>{{ $t('jobDetail.loading') }}</div>
              <RectLoading class="generate-video-loading" background="transparent" rectBackground="#fff"/>
            </div>
          </div>
          <div class="bottom-poster-list">
            <van-tabs
              v-model="activePosterShowTypeIndex"
              class="poster-show-type-tabs"
              line-height="0px"
              title-inactive-color="#000000"
              animated
              @change="handleChangePosterShowType"
            >
              <van-tab
                v-for="(item, index) in posterShowTypes"
                :title="item.label"
                :key="index"
              >
                <template v-if="item.value === 'CUSTOM'" #title>
                  <van-icon name="plus" />
                </template>
                <div class="bottom-poster-list-content">
                  <div
                    v-for="(jobPoster, index) in getCurrentPosterList(item.value)"
                    :key="index"
                    :style="{ backgroundImage: `url(${jobPoster.posterShareImg})` }"
                    @click="changeCurrentPoster(jobPoster)"
                  >
                    <div v-if="item.value === 'AMBASSADOR_POSTER'" class="poster-item">
                      <div class="delete-poster">
                        <i class="el-icon-delete" @click="handleDeletePoster(jobPoster)"></i>
                      </div>
                      <div v-if="isVideoPoster(jobPoster) && jobPoster.ambassador_poster_id !== currentPopPoster.ambassador_poster_id" class="icon-video-play">
                        <div></div>
                        <img src="@/assets/image/jobDetail/play.png"/>
                      </div>
                      <span v-show="jobPoster.ambassador_poster_id === currentPopPoster.ambassador_poster_id" class="iconfont icontick-01"></span>
                    </div>
                    <div v-else class="poster-item">
                      <div v-if="isVideoPoster(jobPoster) && jobPoster.id !== currentPopPoster.id" class="icon-video-play">
                        <div></div>
                        <img src="@/assets/image/jobDetail/play.png"/>
                      </div>
                      <span v-show="jobPoster.id === currentPopPoster.id" class="iconfont icontick-01"></span>
                    </div>
                  </div>
                </div>
              </van-tab>
            </van-tabs>
          </div>
          <div v-show="showDownloadTip || showiOSWechatDownloadTipByTipButton" class="wechat-download-tip">
            <img :src="iOSWechatDownloadTipImageUrl" />
            <div class="got-it-container" @click="closeDownloadTip">
              <span style="font-size: 40px;" class="iconfont icona-gotit"></span>
              <span class="got-it-text">{{ $t('jobDetail.gotIt') }}</span>
            </div>
          </div>
        </div>

        <div id="transition" v-show="transitionShow" ref="transitionShare">
          <span class="close-btn" @click="shareTransitonClose"></span>
          <div class="share-tip-container share">
            <ul class="share-tip">
              <li class="share-to">
                <span class="icon"></span>
                <span>{{ $t('jobDetail.shareToWechat') }}</span>
              </li>
              <li class="step1">
                <span class="icon"></span>
                <span>{{ $t('jobDetail.holdToHighlight') }}</span>
              </li>
              <li class="step2">
                <span class="icon"></span>
                <span>{{ $t('jobDetail.selectCopy') }}</span>
              </li>
              <li class="step3">
                <span class="icon"></span>
                <span>{{ $t('jobDetail.openWeChatAndPaste') }}</span>
              </li>
            </ul>
          </div>

          <div class="share-content">
            <p class="tip">{{ $t('jobDetail.hereIsAJob') }}</p>
            <div class="job-info">
              <div class="job-title">
                {{ job.i18n_name }}
              </div>
              <div class="job-location">
                <span v-for="(item, index) in job.cities" :key="index">
                  {{item.name + ' '}}
                </span>
              </div>
            </div>
            <br>
            <div v-if="hasRefStepsSetting && !isHiddenRewards" class="job-referral">
              <template v-if="is_fosun_company || !has_referral_word_customized">
                {{ $t('jobDetail.upToRMBParm',{ balance: jobReferralRewardsTip }) }}
              </template>
              <template v-else >
                {{ $t('jobDetail.referforRewards') }}
              </template>
            </div>
            <br>
            <div class="detail-link">
              <label>{{ $t('jobDetail.clickHereForMoreInformation') }}</label>
              <p>
                <a class="detail-link-url"></a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- wechat-popup end -->

      <!-- poster create components -->
      <vue-canvas-poster
        :widthPixels="1000"
        :painting="painting"
        @success="successCreateImg"
        @fail="fail">
      </vue-canvas-poster>
      <vue-qr
        :bind-element="false"
        :logoSrc='posterQrcode.logoSrc'
        :text="posterQrcode.text"
        :size="200"
        :qid="qrcodeQidStr"
        :callback="savePreviewQRcodeUrl">
      </vue-qr>
      <!-- poster create components end -->
    </div>
    <!-- chatbot start -->
    <Chatbot
      v-if="(show_chatbot || showAiChatbot) && showPageContent && theJobCanShow  && !isPreview"
      v-show="!hiddenChatbot"
      ref="chatbot"
      class="chatbot"
      :useAiChatbot="showAiChatbot"
      btnDialogToggleBootem="300px"
      nudgeBottom="362px"
      :clickable="!isPreview"
      :generateUserId="user_id"
      :currentAccountId="account?.id"
      :showChatbotMessageBox="showChatbotMessageBox"
      :showReferral="jobToShowReferral"
      :hasReferralIcon="submit_referral"
      :company="company"
      :context="{type: job.hasPrescreenJobSurvey ? 'GET_QUESTIONNAIRE' : null,job_id: job.id,survey_id: job.hasPrescreenJobSurvey && job.prescreenJobSurvey && job.prescreenJobSurvey.id,candidate_id: account.type === 'candidate' ? account.id : '0',question_id: '',answer: '',autoSendText: (job.hasPrescreenJobSurvey && job.prescreenJobSurvey && job.prescreenJobSurvey.id && '进入职位调查问卷') || ''}"
      :henkelWechatAccountOpenId="user_openid_4798"
      :jobId="job.id + ''"
      @applyJob="applyDirectlyNeedStatement(null, $refs.applyDirectly)"
      @referralSubmitInfoShow="showReferralTipDialog"
      />

    <div class="video-navigation-wrapper" :class="isPreview && 'preview'">
      <VideoNavigation
        v-if="video_navigation?.video_list?.length > 0"
        v-show="!showMapContainer"
        class="video-navigation"
        :data="video_navigation.video_list"
        @videoNavigationShowChange="onVideoNavigationShowChange"
      ></VideoNavigation>
    </div>

    <!-- chatbot end -->
    <van-dialog
      v-model="referralUrlDialog.show"
      class="referral-url-dialog"
      :title="referralUrlDialog.title"
      :confirm-button-text="$t('common.btn.copy')"
      :message="referralUrlDialog.url"
      @cancel="onCloseReferralUrlDialog"
      @confirm="onCopyReferralUrl"
    ></van-dialog>
    <WeChatBindQrCodeDialog
      :show.sync="showWeChatBindQrCodeDialog"
      :companyId="company?.root_company.id"
      @close="handleWeChatBindQrCodeDialogClose"
    ></WeChatBindQrCodeDialog>
    <!-- 确认创建提醒 -->
    <JobAlertConfirmDialog
      v-if="!isPreview"
      :show.sync="showJobAlertDialog"
      :companyId="company.id"
      :logo="company.logo"
      :isAgreed="personalAgreementStatus?.is_agreed"
    ></JobAlertConfirmDialog>
  </div>
</template>
<script>
import { Dialog, Divider } from 'vant'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import { addI18nProperty, getI18nPropertyValue, isEn } from '@/i18n'
import NavBar from '@/components/job/navBar/index.vue'
import Chatbot from '@/components/job/chatbot/index.vue'
import ContainerTemplate from '@/components/job/jobDetail/Container.vue'
import ApplyInternalJob from '@/components/job/jobDetail/ApplyInternalJob.vue'
import JobExpired from '@/components/job/jobDetail/JobExpired.vue'
import RectLoading from '@/components/loading/rectLoading.vue'
import MobilePersonalMenu from '@/components/menu/mobilePersonalMenu.vue'
import { VueCanvasPoster } from 'vue-canvas-poster'
import VueQr from 'vue-qr'
import {
  QINIU_DOMAIN,
  CUSTOM_MOBILE_LANDING_CUSTOMIZED_COLOR,
  CUSTOMIZATION_REFERRAL_WORD,
  JD_CUSTOMIZED_IMAGE_ROOT_COMPANY_IDS,
  COLOR_CUSTOMIZED_COMPANY_IDS,
  HENKEL_PROTOCOL
} from '@/constant/common'
import configWxShare, { configWeComShare } from '@/utils/wxShareConfig'
import eventBus from '@/utils/eventBus'
import { md5, deviceType, addQueryInPath } from '@/utils/common'
import {
  resizeDataURL,
  dataUrlToFile,
  uploadBase64Src,
  getBindImageHeight,
  preCompressImage,
  // generateJobDetailPosterFileKey,
  uploadFile
} from '@/utils/qiniu'
import ReferralInfoList from '@/views/job/referralInfoList.vue'
import PaletteButton from '@/views/admin/job/previewComponent/paletteButton.vue'
import VideoNavigation from '@/components/videoNavigation/videoNavigation.vue'
import { JOB_POSTER_SHOW_TYPE, ACCEPT_FILE_SIZE, ACCEPT_VIDEO_DURATION_SECONDS, ACCEPT_VIDEO_FILE_SIZE } from '@/constant/jobPoster'
import WeChatBindQrCodeDialog from '@/views/personal/common/wechatBindQrCodeDialog.vue'
import JobAlertConfirmDialog from '@/components/job/jobDetail/jobAlertConfirmDialog.vue'
import { ROOT_COMPANY_ID } from '@/constant/company'
import { getAMap } from '@/plugins/amap'
import moment from 'moment'
import PopupPolicyDialog from '@/views/company/pc/components/popupPolicyDialog.vue'

const ROLE_TYPE_MAP = {
  F: 'FULL_TIME',
  P: 'PART_TIME',
  I: 'INTERNSHIP'
}

export default {
  metaInfo () {
    return {
      link: this.metaInfoLinkList,
      style: this.metaInfoStyleList
    }
  },
  components: {
    PopupPolicyDialog,
    NavBar,
    Chatbot,
    ContainerTemplate,
    ApplyInternalJob,
    JobExpired,
    VueCanvasPoster,
    RectLoading,
    VueQr,
    ReferralInfoList,
    MobilePersonalMenu,
    PaletteButton,
    VideoNavigation,
    WeChatBindQrCodeDialog,
    JobAlertConfirmDialog
  },
  inject: ['getCustomFontFromTheme'],
  data () {
    return {
      jobPosterI18nPrefix: 'admin.company.jobPoster',
      i18nPrefix: 'admin.job.editor',
      getI18nPropertyValue,
      Divider,
      HENKEL_PROTOCOL,
      // data for vue
      metaInfoLinkList: [],
      metaInfoStyleList: [],
      rewardContent: '',
      rewardContentBalance: '',
      rewardContentShowBanlance: false,
      applyDirectlyUrl: '',
      is_in_root_company_jd_customized_array: false,
      qiniu_domain: QINIU_DOMAIN,
      wxShareInfo: {},
      showChatbotMessageBox: false, // TODO
      user_openid_4798: '', // 4798_user_openid
      customized_header: null,
      customized_footer: null,
      submitInfoUrl: '',
      locationLoadPromise: null,
      jobLocationList: [],
      mapContainerParams: {},
      showMapContainer: false,
      mapLoading: true,
      mapLoader: null,
      mapHasInit: false,
      showStatement: false,
      mapObj: null,
      lng: 121.473701,
      lat: 31.230416,
      henkelAgm2PopupShow: false,
      reviewPopShow: false,
      popTipBottomSubmitShow: false,
      popTipBottomInfoShow: false,
      wechatShareTipShow: false,
      maskShow: false,
      referralTransitionShow: false,
      submitReferralConfirmShow: true, // todo
      submitReferralShareConfirmShow: false,
      wechatPointerShow: false,
      qrcodeTransitionShow: false,
      transitionShow: false,
      qrcodeContentShow: false,
      qrcodeAltShow: true,
      singleJobGroupPopupShow: false,
      tosCheckErrorShow: false,
      hasRefStepsSetting: false,
      jobToShowReferral: null,
      isInternalJob: false,
      showPageContent: false,
      showInternalJob: false,
      showJobExpired: false,
      posterTransitionShow: false,
      saveImgTipShow: false,
      referralIconShow: true,
      posterImgUrl: null,
      qrcodeUrl: null,
      wxShareUrl: null,
      theJobCanShow: false,
      showLoadingIcon: true,
      showJobPoster: false,
      hiddenChatbot: false,

      need_statement_2: false,
      revoke_agreement_applicant: '',
      is_agreed_company_agreement: '',
      is_referral_job: '',
      can_reapply: '',
      cant_applied: '',
      finish_apply: '',
      is_lite_referral: '',
      wechat_login: '',
      is_in_china: '',
      statement_name: '',
      statement_content: '',
      // data from API
      webpage_item: null,
      submit_resume: '',
      // has_webpage_item: '', nouse
      job_detail_has_rewards_rules: 'ture',
      customization_rewards_rules: {
        mode: '',
        tips: '',
        click_label: '',
        dialog_img_mobile: '',
        dialog_img_pc: '',
        dialog_title: ''
      },
      // loadedCompany: false, no use
      hen_agm1: '',
      hen_agm2: '',
      has_policy_link: false,
      referId: '',
      agreePolicy: false,
      show_apply: '',
      is_fosun_company: '',
      has_custom_mobile_landing_page: false,
      has_custom_mobile_landing_page_2: false,
      webpage_title: 'webpage_title',
      about_us: 'about_us',
      group: 'group',
      STATIC_URL: '/static/', // 常量
      media_url: '/media/',
      // pageSettings: {
      color: '',
      company_logo: '',
      // company_webpage_title: '', no use
      custom_mobile_landing_customized_color: false,
      // flat_customized: false, //no use
      has_color_customization: false,
      has_referral_word_customized: false,
      show_survey_entrance: false,

      normal_share_url: ' ',
      show_chatbot: false,
      showAiChatbot: false,
      showNavBar: false,
      user_id: '',
      show_salary: false,
      has_apply: '',
      need_statement: false,
      is_show_henkel_protocol: '',
      is_have_job_poster: false,
      posterQrcode: {
        logoSrc: null,
        text: 'www.ajinga.com',
        url: null
      },
      commonPosterList: [],
      customPosterList: [],
      instructionsPosterList: [],
      ambassadorPosterList: [],
      isGeneratingBgImagePosterId: null,
      posterData: null,
      posterShareImg: null,
      posterVideoShareImg: null,
      posterListData: [],
      currentPopPoster: null,
      qrcodeQid: 0,
      isGeneratingVideo: false,
      hasClickShare: false,
      showiOSWechatDownloadTip: true,
      showiOSWechatDownloadTipByTipButton: false,
      hasClickDownloadButton: false,

      has_referral_share: false,
      jd_customize: '',
      quick_referral_flag: '',
      referral_share_url: '',
      is_external_job_referral: '',
      is_employee_of_company: '',
      quick_referral_id: '',
      submit_referral: '',
      share_og_title: '',
      job: {
        id: '',
        root_company_id: '',
        currency: '',
        cities: [],
        experience: '',
        work_time: '',
        cn_description: '',
        description: '',
        is_in_group: '',
        compensation: null,
        role_type: '',
        job_visibility: null,
        customized_header_en: null,
        customized_footer_en: null,
        customized_header_cn: null,
        customized_footer_cn: null,
        to_show_referral: '',
        i18n_name: '',
        updated_time: new Date(),
        company: {
          logo: '',
          i18n_name: '',
          id: ''
        }
      },
      company: {
        id: '',
        has_referral_word_customized: false,
        has_custom_referral_rewards: false,
        logo: '',
        name: '',
        cn_name: '',
        i18n_name: '',
        is_overseas_company: false,
        root_company: {
          id: ''
        },
        root_company_id: '',
        get_policy_link: ''
      },
      // account: null,
      account: {
        employee: null
      },
      softUser: null,
      wechat_share_info: null,
      ref_steps_setting: {
        employee_real_budget: ' ',
        non_employee_real_budget: ' ',
        probation_budget: {
          // employee: ' ',
          // non_employee: ' '
        },
        onboard_budget: {
          // employee: ' ',
          // non_employee: ' '
        },
        interviewed: {
          // points: ' ',
          // count: ' '
        },
        applied: {
          // count: ' ',
          // points: ' '
        }
      },
      painting: {
      },
      initStatus: {
        detailInfo: false,
        applyStatus: false,
        referralSetting: false
      },
      posterPaintingPromise: null,
      posterPaintingPromiseResolve: null,
      qrCodePromise: null,
      qrCodePromiseResolve: null,
      has_answered: false,
      addPotentialTimer: null,
      referralUrlDialog: {
        title: '',
        url: '',
        show: false
      },
      companyPolicyInfo: {
        id: null,
        type: null,
        html_content: null
      },
      video_navigation: null,
      activePosterShowTypeIndex: 0,
      isAmbassador: false,
      newJobPosterImages: [],
      currentPosterShowType: 'COMMON',
      showWeChatBindQrCodeDialog: false,
      custom_referral_title: false,
      showJobAlertDialog: false,
      personalAgreementStatus: null,
      surveyInfo: {}
    }
  },
  props: {
    isPreview: {
      type: Boolean,
      default: false
    },
    jobDetailInfo: {
      type: Object
    },
    jobAndCompanyInfo: {
      type: Object
    },
    previewWebpagItem: {
      type: Array
    },
    aboutUsPreview: {
      type: String,
      default: 'about_us'
    },
    hasCustomMobileLandingPage2: {
      type: Boolean,
      default: false
    },
    hasCustomMobileLandingPage: {
      type: Boolean,
      default: false
    },
    showApply: {
      type: Boolean,
      default: false
    },
    updateTime: {
      type: String,
      default: ''
    },
    groupName: {
      type: String,
      default: 'group'
    }
  },
  computed: {
    ...mapGetters('account', ['wxUserHasBindRewards', 'isCandidateAccount']),
    posterShowTypes () {
      const list = [
        {
          label: this.$t(`${this.jobPosterI18nPrefix}.label.companyJobPoster`),
          value: 'COMMON',
          hidden: !this.commonPosterList.length
        },
        {
          label: this.$t(`${this.jobPosterI18nPrefix}.label.ambassadorJobPoster`),
          value: 'AMBASSADOR_POSTER',
          hidden: !this.isAmbassador || !this.ambassadorPosterList.length
        },
        {
          label: this.$t(`${this.jobPosterI18nPrefix}.label.customJobPoster`),
          value: 'CUSTOM',
          hidden: !this.isAmbassador || !this.customPosterList.length
        },
        {
          label: this.$t(`${this.jobPosterI18nPrefix}.label.instructionsJobPoster`),
          value: 'INSTRUCTIONS',
          hidden: !this.isAmbassador || !this.instructionsPosterList.length
        }
      ]
      return _.filter(list, item => !item.hidden)
    },
    languageCode () {
      return this.$i18n.locale
    },
    getWorkTime () {
      return this.isPreview
        ? (this.job.work_time.id === -1 ? this.$t('jobDetail.notSpecified') : getI18nPropertyValue(this.job.work_time.item, 'cn_name', 'name'))
        : (this.job.work_time ? this.job.work_time.name : this.$t('jobDetail.notSpecified'))
    },
    isInJoywok () {
      // const userAgent = navigator.userAgent
      // return userAgent.indexOf('Joywok') !== -1
      return false
    },
    shortId () {
      return this.$route.params.jobId
    },
    showPolicyPopup () {
      return this.$route.query.show_policy_popup === '1'
    },
    goToSubmit () {
      return this.$route.query.go_to_submit === '1'
    },
    qrcodeQidStr () {
      return this.qrcodeQid.toString()
    },
    isiOSWechat () {
      return deviceType.isWeChat && deviceType.isiOS
    },
    showDownloadTip () {
      return this.isiOSWechat && this.showiOSWechatDownloadTip && this.isVideoPoster(this.currentPopPoster) && this.hasClickDownloadButton
    },
    iOSWechatDownloadTipImageUrl () {
      return `https://static-c.ajinga.com/icon/download-tip-${this.languageCode === 'en' ? 'en' : 'cn'}.gif`
    },
    hideReferralProgram () {
      const account = this.getCurrentAccount()
      return Boolean(account?.employee?.company.hide_referral_program)
    },
    hasLogin () {
      const account = this.getCurrentAccount()
      return Boolean(account?.id)
    },
    accountIsExits () {
      // 这里用于判断是否需要展示询问是否是员工弹窗，soft user 需要弹出，所以在这里不算登录
      const account = this.getCurrentAccount()
      if (account?.id) {
        return true
      } else {
        return false
      }
    },
    isEmployeeAccount () {
      const account = this.getCurrentAccount()
      return Boolean(account?.employee?.id)
    },
    jobReferralRewardsTip () {
      const setpsSetting = this.ref_steps_setting
      if (!setpsSetting) {
        return ''
      }

      let realBudget = null
      if (this.is_employee_of_company) {
        realBudget = setpsSetting.employee_real_budget
      } else {
        realBudget = setpsSetting.non_employee_real_budget
      }

      const payroll = parseFloat(realBudget.payroll || 0)
      const points = parseInt(realBudget.points || 0)
      let cash = parseFloat(realBudget.cash || 0)
      cash += payroll
      const text = []
      if (cash > 0) {
        // 针对特殊的公司，需要在展示奖励的时候用 积分(points) 代替 元(yuan)，一般是针对员工这样展示
        if (this.isUsePointReplacePayroll) {
          text.push(this.$t('jobDetail.label.reward.points', { reward: this.formatBigAmount(parseInt(cash)) }))
        } else {
          text.push(this.$t('jobDetail.label.reward.cash', { reward: this.formatBigAmount(parseInt(cash)) }))
        }
      }
      if (points > 0) {
        text.push(this.$t('jobDetail.label.reward.points', { reward: this.formatBigAmount(points) }))
      }
      return text.join(', ')
    },
    quickReferralUrl () {
      let url = `/referral/quick-referral/${this.job.id}/`
      if (this.referId) {
        url += `${this.referId}/`
      }
      return this.$DjangoBaseUrl(url)
    },
    displayJobFieldInfoList () {
      const list = []
      const companyJobFilters = this.jobDetailInfo.company_job_filters || []
      const customFields = this.jobDetailInfo.custom_fields || []
      const salary = {
        labelI18nKey: `${this.i18nPrefix}.label.jobDetailSalary`,
        ...this.jobDetailInfo.compensation,
        order: 5
      }
      const workTime = {
        labelI18nKey: `${this.i18nPrefix}.label.jobDetailWorkTime`,
        ...this.jobDetailInfo.work_time,
        order: 4
      }
      if (this.jobDetailInfo.work_time) {
        addI18nProperty(workTime, 'value', 'cn_name', 'en_name')
      } else {
        workTime.valueI18nKey = `${this.i18nPrefix}.label.experienceUnlimited`
      }
      const roleType = {
        labelI18nKey: `${this.i18nPrefix}.label.jobDetailRoleType`,
        valueI18nKey: `${this.i18nPrefix}.roleType.${this.jobDetailInfo.roleType}`,
        order: 3
      }
      const experience = {
        labelI18nKey: `${this.i18nPrefix}.label.jobDetailExperience`,
        value: this.getJobExperience(this.jobDetailInfo.experience),
        order: 2
      }
      const updateTime = {
        labelI18nKey: 'jobDetail.updateTime',
        value: this.formatTime(this.jobDetailInfo.updated_time),
        order: 1
      }
      addI18nProperty(salary, 'value', 'cn_name', 'en_name')
      _.forEach(companyJobFilters, filter => {
        if (filter.name === 'Location') {
          return
        }
        const displayOrder = filter.display_order_in_jd
        if (this.job.root_company_id !== 4335 && filter.name === 'Work Time') {
          workTime.order = displayOrder
          list.push(workTime)
        } else if (filter.name === 'Salary' && this.show_salary) {
          salary.order = displayOrder
          list.push(salary)
        } else if (filter.name === 'Role Type') {
          roleType.order = displayOrder
          list.push(roleType)
        } else if (filter.name === 'Experience') {
          experience.order = displayOrder
          list.push(experience)
        } else if (filter.name === 'Updated Time') {
          updateTime.order = displayOrder
          list.push(updateTime)
        } else {
          const customField = _.find(customFields, item => item.name === filter.name)
          const filterValue = customField ? customField.filter_value : null
          const filterValueItems = customField ? customField.filter_value_items : []
          const displayValue = addI18nProperty(filter, 'label', 'cn_name', 'name')
          filter.order = displayOrder
          if (_.includes(['SELECT', 'SINGLE'], filter.type) && filterValueItems?.length) {
            displayValue.value = _.chain(filterValueItems).map(item => _.get(item, isEn() ? 'name' : 'cn_name')).join(isEn() ? ', ' : '，').value()
          } else if (filterValue) {
            displayValue.value = filterValue
          }
          list.push(displayValue)
        }
      })
      return _.orderBy(list, ['order'], 'desc')
    },
    isHiddenRewards () {
      return Boolean(this.company?.premium?.hidden_rewards)
    },
    isUsePointReplacePayroll () {
      return Boolean(this.is_employee_of_company && this.company?.premium?.use_point_replace_payroll)
    },
    isADPCompany () {
      return Boolean(this.company?.root_company?.id === 7496)
    },
    isCoachCompany () {
      return Boolean(this.company?.root_company?.id === 592)
    },
    quickReferralBindWeChatUrl () {
      const back = this.$route.fullPath
      return this.$DjangoBaseUrl(`/referral/wechat-binding/?back=${encodeURIComponent(back)}`)
    },
    showReferralSubmit () {
      if (this.company.root_company.id === 6143) {
        if (this.submit_referral && this.is_employee_of_company) {
          return true
        } else {
          return false
        }
      } else if (this.submit_referral) {
        return true
      } else {
        return false
      }
    },
    shareJobLoginFail () {
      return !this.hasLogin && this.$route.query.code_fail === '1' && this.$route.query.is_job_share_login === '1'
    },
    showReferralBtn () {
      if (!this.jd_customize || this.to_show_referral) {
        return true
      }
      const buttonItems = getI18nPropertyValue(this.jobDetailInfo.all_button_items, 'zh', 'en')
      const referralBtnSetting = _.find(buttonItems, item => item.key === 'referral_btn')
      if (referralBtnSetting) {
        return referralBtnSetting.show
      }
      return true
    },
    hasHiddenPoweredWord () {
      return this.hasAnyPermission('PREMIUM_HIDDEN_WEB_PAGE_BOTTOM_STATEMENT') || this.company.has_hidden_web_page_bottom_statement_premium
    },
    hiddenReferShare () {
      return this.company?.root_company?.id === ROOT_COMPANY_ID.MERCEDES_BENZ
    },
    hasReferralPermission () {
      return this.company.premium?.referral
    },
    companyBrandingUrl () {
      return { path: `/recruiting/company/${this.company.id}/branding`, query: this.$route.query }
    },
    companyLandingUrl () {
      return { path: `/recruiting/company/${this.company.id}/landing`, query: this.$route.query }
    },
    jobCompanyBrandingUrl () {
      return { path: `/recruiting/company/${this.job.company.id}/branding`, query: this.$route.query }
    }
  },
  created () {
    this.initPageData()
  },
  beforeDestroy () {
    if (document.getElementsByClassName('footer').length) {
      document.getElementsByClassName('footer')[0].style.display = 'block'
    }
  },
  methods: {
    ...mapGetters('account', ['getCurrentAccount', 'getUserUUID', 'getCurrentSoftUser']),
    ...mapActions('common', ['saveCommonUserBehavior', 'getMediaInfo', 'watermarkVideo', 'getMediaPrefopStatus', 'batchDeletePosterImage']),
    ...mapActions('chatbot', ['chatbotClickApplyJobButton']),
    ...mapActions('job', [
      'getSubmitInfoEncrypt',
      'getReferralEarnRewards',
      'getJobLocations',
      'countShareTimes',
      'getJobQrCode',
      'getLoginStatus',
      'getJobReferralSetting',
      'getJobApplyStatus',
      'getJobDetailJobPoster',
      'addPotentialCandidates'
    ]),
    ...mapActions('joywok', ['checkAutoLogin', 'getEmployeeInfo', 'getJoywokConfigParams']),
    ...mapActions('company', ['getCustomJobDetailPageInfo', 'getCompanyBaseInfo', 'getCompanyPolicyInfo']),
    ...mapActions('eventTrack', ['trackCandidateViewJobDetail', 'trackCandidateShareJobDetail']),
    ...mapActions('jobPosterAmbassador', ['checkAccountIsAmbassador', 'uploadAmbassadorJobPoster', 'deleteAmbassadorJobPoster']),
    ...mapActions('personal', ['getAgreementStatus']),
    ...mapActions('survey', ['getSurveyInfo']),
    async handleUploadPoster (fileInfo) {
      const file = fileInfo.file
      const fileType = file.type
      const language = this.languageCode === 'en' ? 'en' : 'cn'
      const fileKey = `ambassador-poster/${this.company.id}/${language}/${fileType}/${new Date().valueOf()}`
      this.$eventBus.$emit('showLoading', true)
      this.posterTransitionShow = false
      try {
        const resp = await uploadFile(file, fileKey)
        if (resp) {
          this.fileKey = resp.key
          const posterInfo = {
            company_id: this.company.id,
            job_poster_id: this.currentPopPoster.id,
            poster_url: fileKey
          }
          await this.uploadAmbassadorJobPoster(posterInfo)
          this.newJobPosterImages = []
          const shareLink = this.referral_share_url || this.normal_share_url
          await this.loadJobPosterList(shareLink)
        }
      } finally {
        this.activePosterShowTypeIndex = 1
        this.handleChangePosterShowType()
        this.posterTransitionShow = true
        this.$eventBus.$emit('showLoading', false)
      }
    },
    beforeUploadPoster (file) {
      const canUploadFileType = this.currentPopPoster.poster_type
      const fileType = file.type
      let msg = null

      if (/image/.test(fileType)) {
        if (file.size > ACCEPT_FILE_SIZE) {
          msg = this.$t(`${this.jobPosterI18nPrefix}.message.wrongImageSize`, { size: ACCEPT_FILE_SIZE / (1024 * 1024) })
        }
      } else if (/video/.test(fileType)) {
        const url = URL.createObjectURL(file)
        const audioElement = new Audio(url)
        audioElement.addEventListener('loadedmetadata', () => {
          this.newVideoJobPosterDuration = parseInt(audioElement.duration)
        })
        if (file.size > ACCEPT_VIDEO_FILE_SIZE || this.newVideoJobPosterDuration > ACCEPT_VIDEO_DURATION_SECONDS) {
          msg = this.$t(`${this.jobPosterI18nPrefix}.message.wrongVideoSize`, { size: ACCEPT_VIDEO_FILE_SIZE / (1024 * 1024), duration: ACCEPT_VIDEO_DURATION_SECONDS })
        }
      } else {
        msg = canUploadFileType === 'img' ? this.$t(`${this.jobPosterI18nPrefix}.message.wrongImageType`) : this.$t(`${this.jobPosterI18nPrefix}.message.wrongVideoType`)
      }

      if (msg) {
        this.$message.info({
          message: msg,
          customClass: 'message-override'
        })
        return false
      }

      return true
    },
    async handleDeletePoster (jobPoster) {
      if (!jobPoster.ambassador_poster_id) {
        return
      }
      this.posterTransitionShow = false
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.deleteAmbassadorJobPoster({ companyId: this.company.id, ambassadorPosterId: jobPoster.ambassador_poster_id })
        let msg = ''
        if (resp) {
          msg = `${this.jobPosterI18nPrefix}.message.deleteAmbassadorPosterSuccess`
        } else {
          msg = `${this.jobPosterI18nPrefix}.message.deleteAmbassadorPosterFail`
        }
        this.$message.info({
          message: this.$t(msg),
          customClass: 'message-override'
        })
      } finally {
        const shareLink = this.referral_share_url || this.normal_share_url
        await this.loadJobPosterList(shareLink)
        const posterList = this.getCurrentPosterList(this.currentPosterShowType)
        if (posterList.length) {
          this.posterTransitionShow = true
          this.changeCurrentPoster(posterList[0])
        } else {
          this.shareTransitonClose()
        }
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async checkCurrentAccountIsAmbassador () {
      if (this.isPreview) {
        return
      }
      const resp = await this.checkAccountIsAmbassador({ job_short_id: this.shortId })
      this.isAmbassador = resp
    },
    handleChangePosterShowType () {
      this.currentPosterShowType = this.posterShowTypes[this.activePosterShowTypeIndex].value
      const posterList = this.getCurrentPosterList(this.currentPosterShowType)
      if (!posterList.length) {
        return
      }
      this.changeCurrentPoster(posterList[0])
    },
    getCurrentPosterList (showType) {
      if (showType === JOB_POSTER_SHOW_TYPE.COMMON) {
        return this.commonPosterList
      } else if (showType === JOB_POSTER_SHOW_TYPE.CUSTOM) {
        return this.customPosterList
      } else if (showType === JOB_POSTER_SHOW_TYPE.INSTRUCTIONS) {
        return this.instructionsPosterList
      } else {
        return this.ambassadorPosterList
      }
    },
    async initPageData () {
      this.checkCurrentAccountIsAmbassador()
      this.account = this.getCurrentAccount()
      this.softUser = this.getCurrentSoftUser()
      if (this.showPolicyPopup) {
        this.showStatement = true
      }
      if (!this.isPreview) {
        await this.initJobDetailInfo(this.jobAndCompanyInfo)
        this.initReferralSetting()
        this.initApplyInfo()
        this.loadCompanyPolicyInfo()
        this.initCustomPageInfo()
        this.trackCandidateEvent()
        this.initPersonalAgreementStatus()
        this.initSurveyInfo()
        await this.getCompanyBaseInfo({ id: this.company.id }).then(resp => {
          if (resp) {
            this.showAiChatbot = resp.show_ai_chatbot
            this.show_survey_entrance = resp.show_survey_entrance
            this.has_answered = resp.has_answered
          }
        })
      }
      if (this.isPreview) {
        if (this.jobDetailInfo.company.id) {
          this.$eventBus.$emit('showLoading', true)
          if (document.getElementsByClassName('footer').length) {
            document.getElementsByClassName('footer')[0].style.display = 'none'
          }
          await this.getCompanyBaseInfo({ id: this.jobDetailInfo.company.id }).then(resp => {
            if (resp) {
              const { company } = resp
              this.company = { ...resp.company, ...resp }
              this.show_chatbot = resp.show_chatbot
              this.has_color_customization = resp.has_color_customization
              this.show_survey_entrance = resp.show_survey_entrance
              this.show_salary = company.show_salary
              this.jd_customize = company.jd_customize
              this.show_apply = this.showApply
              if (this.jobDetailInfo.enable_company_job_customization && this.previewWebpagItem) {
                this.webpage_item = this.previewWebpagItem
              } else {
                this.webpage_item = []
              }
              this.job = { ...this.job, ...this.jobDetailInfo }
              this.jobLocationList = this.jobDetailInfo.job_locations.map(item => {
                return {
                  address: item.address,
                  city: item.city,
                  id: item.id,
                  latitude: item.lat,
                  longitude: item.lng
                }
              })
              this.video_navigation = {
                video_list: isEn() ? this.jobDetailInfo.video_navigation_list[1] : this.jobDetailInfo.video_navigation_list[0]
              }
              this.showLoadingIcon = false
              this.getCustomizedParse()
              if (this.jobDetailInfo.short_unique_id) {
                this.initReferralSetting()
                this.initApplyInfo()
                this.initRewardContent()
              }
              this.initPageCss()
            }
          })
          this.$eventBus.$emit('showLoading', false)
        }
      }
      if (this.goToSubmit && this.submit_referral && (!this.jobToShowReferral) && this.hasLogin) {
        this.showStatement = false
        this.submitResume()
      } else if (this.goToSubmit && this.submit_referral && (!this.jobToShowReferral)) {
        this.showStatement = false
        this.popTipBottomSubmitShow = true
        this.submitReferralConfirmShow = true
      }
      if (this.shareJobLoginFail) {
        this.$message({
          type: 'warning',
          message: this.$t('common.message.shareJobLoginFail')
        })
      }
    },
    handleGetQrCode () {
      if (!this.company?.root_company.id) {
        return
      }
      this.closePopupEvent()
      this.showWeChatBindQrCodeDialog = true
    },
    handleWeChatBindQrCodeDialogClose () {
      this.shareIconClick()
    },
    async initJobDetailInfo (resp) {
      this.$eventBus.$emit('showLoading', true)
      try {
        // let hasCheckeSSO = false
        // if (this.isInJoywok) {
        //   if (!(this.account && this.account.id)) {
        //     await this.checkStarbucksSSO()
        //     hasCheckeSSO = true
        //   }
        // }
        this.initStatus.detailInfo = true
        if (!resp) {
          this.$message.error(this.$t('error.message.serverError'))
          return
        }
        const respType = resp && resp.type
        _.forEach(resp.data || {}, (value, key) => {
          this[key] = value
        })
        if (this.job.root_company_id) {
          const rootCompany = { ...this.company.root_company, id: this.job.root_company_id }
          this.$set(this.company, 'root_company', rootCompany)
        } else if (this.company.id) {
          this.job.root_company_id = this.company.id
          const rootCompany = { ...this.company.root_company, id: this.job.root_company_id }
          this.$set(this.company, 'root_company', rootCompany)
        }
        if (this.job.job_visibility) {
          this.isInternalJob = this.job.job_visibility === 'I'
        }
        if (this.jobDetailInfo.compensation) {
          addI18nProperty(this.jobDetailInfo.compensation, 'name', 'cn_name', 'en_name')
        }
        if (this.jobDetailInfo) {
          this.jobDetailInfo.roleType = ROLE_TYPE_MAP[this.jobDetailInfo.role_type]
        }
        await this.initPageCss()
        if (respType === 'internalJob') {
          this.showPageContent = false
          this.showInternalJob = true
        } else if (respType === 'expiredJob') {
          this.showPageContent = false
          this.showJobExpired = true
        } else if (respType === 'success') {
          this.showPageContent = true
          this.has_referral_word_customized = CUSTOMIZATION_REFERRAL_WORD.indexOf(this.company.root_company.id) > -1
          if (JD_CUSTOMIZED_IMAGE_ROOT_COMPANY_IDS.indexOf(Number(this.job.root_company_id)) > -1) {
            this.is_in_root_company_jd_customized_array = true
          } else {
            this.is_in_root_company_jd_customized_array = false
          }
          this.getCustomizedParse()
          this.theJobCanShow = true
          this.initRewardContent()
          this.initWechatShare(true, this.initStatus.applyStatus)
          this.setApplyDirectlyUrl(true, this.initStatus.applyStatus)
          this.$nextTick(() => {
            this.initJobLocations(() => {
              this.getJobLocationsByLatLng()
            })
          })
          setTimeout(() => this.saveCommonUserBehavior(this.job.id), 20000)
        }
        // if (!hasCheckeSSO) {
        //   await this.checkStarbucksSSO()
        // }
        this.submit_referral = Boolean(this.submit_referral)
        this.addPotentialTimer = setTimeout(() => {
          const params = { refer_id: this.referId, job_id: this.job.id, company_id: this.company.id }
          this.addPotentialCandidates(params)
        }, 20000)
      } catch (err) {
        if (!err.hasOwnProperty('code')) {
          throw err
        }
        if (err.code === 20001001) {
          Dialog.alert({
            message: this.$t('error.code[20001001]')
          })
        } else if (err.code === 20001002) {
          Dialog.alert({
            message: this.$t('error.code[20001002]')
          })
        } else if (err.code === 20001003) {
          Dialog.alert({
            message: this.$t('error.code[20001003]')
          })
        } else {
          eventBus.$emit('responseErrorCode', err.code, err)
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async initReferralSetting () {
      const resp = await this.getJobReferralSetting({
        short_id: this.isPreview ? this.jobDetailInfo.short_unique_id : this.shortId
      })
      if (resp) {
        _.forEach(resp, (value, key) => {
          this[key] = value
        })
        if (resp.ref_steps_setting && this.to_show_referral) {
          this.hasRefStepsSetting = true
        }
        if (this.is_employee_of_company) {
          this.rewardContentBalance = this.ref_steps_setting.employee_real_budget
        } else {
          this.rewardContentBalance = this.ref_steps_setting.non_employee_real_budget
        }
        this.jobToShowReferral = this.to_show_referral && !this.isInternalJob
      }
      this.initStatus.referralSetting = true
    },
    async loadCompanyPolicyInfo () {
      const resp = await this.getCompanyPolicyInfo({ companyId: this.company.id })
      if (resp) {
        if (_.has(resp, 'popup')) {
          this.need_statement = true
        } else if (_.has(resp, 'link')) {
          this.need_statement_2 = true
          addI18nProperty(resp.link[0], 'i18nContent', 'content_cn', 'content_en')
        }
        this.companyPolicyInfo = resp
      }
    },
    async initApplyInfo () {
      const params = { short_id: this.isPreview ? this.jobDetailInfo.short_unique_id : this.shortId, refer_id: this.$route.query.referId }
      const resp = await this.getJobApplyStatus(params)
      _.forEach(resp, (value, key) => {
        this[key] = value
      })
      if (this.submit_resume && this.submit_referral) {
        this.popTipBottomSubmitShow = true
      }
      this.initWechatShare(this.initStatus.detailInfo, true)
      this.setApplyDirectlyUrl(this.initStatus.detailInfo, true)
      this.initStatus.applyStatus = true
    },
    async initCustomPageInfo () {
      const resp = await this.getCustomJobDetailPageInfo({
        short_id: this.shortId,
        is_mobile: true
      })
      if (resp) {
        _.forEach(resp, (value, key) => {
          this[key] = value
        })
        if (this.job.enable_company_job_customization && resp.webpage_item && resp.webpage_item.length > 0) {
          this.webpage_item = JSON.parse(this.webpage_item)
        } else {
          this.webpage_item = null
        }
      }
    },
    async trackCandidateEvent () {
      await this.trackCandidateViewJobDetail({
        short_id: this.shortId
      })
    },
    async initPersonalAgreementStatus () {
      if (!this.hasLogin || !this.isCandidateAccount) {
        return
      }
      const resp = await this.getAgreementStatus({
        company_id: this.company.id
      })
      if (resp) {
        this.personalAgreementStatus = resp
      }
    },
    async initSurveyInfo () {
      if (!this.hasLogin || !this.isCandidateAccount) {
        return
      }
      const resp = await this.getSurveyInfo(this.company.id)
      if (resp) {
        this.surveyInfo = resp
      }
    },
    async initWechatShare (hasDetailInfo, hasApplyStatusInfo) {
      // hasDetailInfo: has finished init Detail info
      // hasApplyStatusInfo: has finished init ApplyStatus info
      if (!hasDetailInfo || !hasApplyStatusInfo) {
        return
      }
      this.wxShareInfo = JSON.parse(this.wechat_share_info)
      if (this.wxShareInfo && this.wxShareInfo.is_activated) {
        this.$eventBus.$emit('setCustomTitle', this.wxShareInfo.moment_title)
      } else {
        this.$eventBus.$emit('setCustomTitle', this.$t('jobDetail.pageTitle'))
      }
      if (this.account?.id || this.softUser?.id) {
        const jobId = this.job.id
        if (!jobId) {
          return
        }
        let earnRewardsUrl = '/referral/earn-rewards/' + jobId + '/'
        const referId = this.referId
        if (referId && referId !== 'None') {
          earnRewardsUrl = earnRewardsUrl + referId + '/'
        }
        earnRewardsUrl = earnRewardsUrl + '?temp=true'
        const res = await this.getReferralEarnRewards(earnRewardsUrl)
        if (res.status === 'success') {
          if (res.refer_url) {
            const referUrl = this.formatShareUrl(res.refer_url)
            this.wxShareUrl = referUrl
          }
        }
      }
      if (!this.wxShareUrl) {
        this.wxShareUrl = this.normal_share_url
      }
      this.wxShareInfo.normal_share_url = this.wxShareUrl
      this.wxShareInfo.page_type = 'JobDetail'
      // this.wxShareInfo.success = () => {
      //   this.trackCandidateShareJobDetail({
      //     job_id: this.job.id
      //   })
      // }
      if (deviceType.isWeChatWork) {
        configWeComShare(this.wecom_app_info, this.wxShareInfo)
      } else {
        configWxShare(this, this.job.id, this.company.root_company?.id, this.company.id)
      }
    },
    initRewardContent () { // 页面加载，获取job和company数据后调用该方法，初始化标签内容
      if (this.is_fosun_company) {
        this.rewardContent = this.$t('jobDetail.refer')
      } else if (this.has_referral_word_customized) {
        this.rewardContent = this.$t('jobDetail.referTalentsForRewards')
      } else {
        this.rewardContentShowBanlance = true
      }
    },
    initPageCss () {
      const company = this.company
      const hasColorCustomization = this.has_color_customization
      // const needStatement = this.need_statement
      const showChatbot = this.show_chatbot
      const customMobileLandingCustomizedColor = this.customMobileLandingCustomizedColor || this.company.custom_color
      const rootCompanyId = company.root_company.id || this.company.company.root_company.id
      const customCompanyColor = company.custom_color || this.company.company.custom_color
      let baseUrl = process.env.VUE_APP_STYLE_BASE_URL
      if (baseUrl.endsWith('/')) {
        baseUrl = baseUrl.substring(0, baseUrl.length - 1)
      }
      const styleList = []
      const linkList = [
        {
          rel: 'stylesheet',
          href: `${baseUrl}/static/style/mobile_web/style_common.css`
        },
        {
          rel: 'stylesheet',
          href: `${baseUrl}/static/style/mobile_web/style_zh.css`
        },
        {
          rel: 'stylesheet',
          href: `${baseUrl}/static/style/mobile_web/company_landing_page_customized.css`
        },
        {
          rel: 'stylesheet',
          href: `${baseUrl}/static/style/mobile_web/job_detail.css`
        }
      ]
      if (COLOR_CUSTOMIZED_COMPANY_IDS.indexOf(rootCompanyId) > -1) {
        linkList.push({
          rel: 'stylesheet',
          href: `${baseUrl}/static/style/mobile_web/company_${rootCompanyId}_customized.css`
        })
      }
      if (hasColorCustomization) {
        styleList.push(`
          body {
            --custom-color: ${customCompanyColor};
          }
        `)
        linkList.push({
          rel: 'stylesheet',
          href: `${baseUrl}/static/style/mobile_web/mobile_color_customization.css`,
          callback: () => { this.showPageContent = true }
        })
      }
      // if (needStatement) {
      //   linkList.push({
      //     rel: 'stylesheet',
      //     href: `${baseUrl}/static/style/mobile_web/company_policy_popup.css`
      //   })
      // }
      if (showChatbot) {
        linkList.push({
          rel: 'stylesheet',
          href: `${baseUrl}/static/style/henkel-bot.css`
        })
      }
      if (customMobileLandingCustomizedColor) {
        const color = CUSTOM_MOBILE_LANDING_CUSTOMIZED_COLOR[rootCompanyId]
        styleList.push(`
          .company-customized,
          #main #referral-share-confirm .btn {
            color: ${color} !important;
          }
        `)
      }
      if (customCompanyColor) {
        styleList.push(`
          .job-detail-info .loading-apply-status .rect-loading.loading-mask .loading-spinner .spinner > div {
            background-color: ${customCompanyColor};
          }
        `)
      }
      const metaInfoStyleList = [
        {
          innerHTML: styleList.join('\n')
        }
      ]
      const allPromise = _.map(linkList.concat(metaInfoStyleList), item => {
        return new Promise((resolve, reject) => {
          item.callback = resolve
        })
      })
      this.metaInfoLinkList = linkList
      this.metaInfoStyleList = metaInfoStyleList
      return Promise.all(allPromise)
    },
    getCustomizedParse () {
      if (this.languageCode === 'en') {
        if (this.job.customized_header_en) {
          this.customized_header = JSON.parse(this.job.customized_header_en)
        }
        if (this.job.customized_footer_en) {
          this.customized_footer = JSON.parse(this.job.customized_footer_en)
        }
      } else {
        if (this.job.customized_header_cn) {
          this.customized_header = JSON.parse(this.job.customized_header_cn)
        }
        if (this.job.customized_footer_cn) {
          this.customized_footer = JSON.parse(this.job.customized_footer_cn)
        }
      }
      if (!this.customized_header) {
        this.customized_header = []
      }
      if (!this.customized_footer) {
        this.customized_footer = []
      }
    },
    successCreateImg (src) {
      const currentPosterList = this.getCurrentPosterList(this.currentPosterShowType)
      const posterId = this.currentPosterShowType === 'AMBASSADOR_POSTER' ? 'ambassador_poster_id' : 'id'
      const currentGenerateBgImgPoster = currentPosterList.find((item) => _.get(item, posterId) === this.isGeneratingBgImagePosterId)
      if (!currentGenerateBgImgPoster) {
        return
      }
      // 合成后的图片，不论是图片海报的还是视频海报需要的图片都存起来
      currentGenerateBgImgPoster.bgImageSrc = src
      if (this.posterPaintingPromise && this.posterPaintingPromiseResolve) {
        this.posterPaintingPromiseResolve(src)
      }
      if (this.isGeneratingVideo && this.isVideoPoster(this.currentPopPoster)) {
        this.$message.info({
          message: this.$t('jobDetail.videoIsGenerating'),
          customClass: 'message-override'
        })
        this.handleVideoCompound(src, this.currentPopPoster)
      } else {
        this.posterImgUrl = src
      }
      this.isGeneratingBgImagePosterId = null
    },
    fail (err) {
      // eslint-disable-next-line no-console
      console.error(err)
    },
    onBackBtnIconClick () {
      if (this.showMapContainer) {
        this.showMapContainer = !this.showMapContainer
        // if (!this.has_custom_mobile_landing_page) {
        //   this.$refs.shareLinkContainer.classList.remove('hide')
        // }
        this.$refs.jobDetailInformationContanier.style.display = 'block'
        if (this.$refs.applybtnGroup) {
          this.$refs.applybtnGroup.style.display = 'block'
        }
        this.referralIconShow = true
        this.hiddenChatbot = false
      } else {
        this.$router.back()
      }
    },
    async onMapBtnIconClick () {
      if (!this.showMapContainer) {
        this.hiddenChatbot = true
        this.referralIconShow = false
        if (this.$refs.applybtnGroup) {
          this.$refs.applybtnGroup.style.display = 'none'
        }
        this.$refs.jobDetailInformationContanier.style.display = 'none'
        // if (!this.has_custom_mobile_landing_page) {
        //   this.$refs.shareLinkContainer.classList.add('hide')
        // }
        this.showMapContainer = true
        await this.renderLocationMap()
        this.setSelectedItem()
      }
    },
    henkelAgm2PopupHide () {
      this.henkelAgm2PopupShow = false
    },
    reviewPopHide () {
      this.reviewPopShow = false
      document.querySelector('body').style.overflow = ''
    },
    handleCancelBtnClick () {
      this.showStatement = false
    },
    async handleAgreeBtnClick ({ policyItemIds, isAgreedSystemPolicy }) {
      if (this.need_statement_2) {
        policyItemIds = _.map(this.companyPolicyInfo.link, item => item.id)
      }
      let applyUrl = `/a/${this.shortId}/`
      if (this.referId) {
        applyUrl = `${applyUrl}${this.referId}/`
      }
      applyUrl = `${applyUrl}?need_edit_resume=1&is_apply_job=1&agreed_policy_items=${policyItemIds.join(',')}&is_agreed_system_policy=${isAgreedSystemPolicy || ''}`
      const params = {
        aj_source: this.$route.query.aj_source,
        aj_code: this.$route.query.aj_code
      }
      applyUrl = addQueryInPath(applyUrl, params, true)
      window.location.href = applyUrl
      this.showStatement = false
    },
    setApplyDirectlyUrl (hasDetailInfo, hasApplyStatusInfo) {
      if (!hasDetailInfo || !hasApplyStatusInfo) {
        return
      }
      if (this.redirect_url) {
        this.applyDirectlyUrl = this.redirect_url
      } else {
        let url = `/apply-job-process/${this.job.id}/?need_edit_resume=1`
        if (this.referId) {
          url += `&referId=${window.encodeURIComponent(this.referId)}`
        }
        const params = {
          aj_source: this.$route.query.aj_source,
          aj_code: this.$route.query.aj_code
        }
        url = addQueryInPath(url, params, true)
        this.applyDirectlyUrl = url
      }
    },
    onMenuIconClick () {
      if (this.showNavBar) {
        this.showNavBar = false
      } else {
        this.showNavBar = true
      }
    },
    commonCloseClick () {
      this.popTipBottomSubmitShow = false
      this.popTipBottomInfoShow = false
      if (deviceType.isWeChat || this.isInJoywok) {
        this.wechatShareTipShow = false
      }
    },
    closePopupEvent () {
      this.referralTransitionShow = false
      this.hiddenChatbot = false
      this.maskShow = false
      if (deviceType.isWeChat || this.isInJoywok) {
        this.wechatShareTipShow = false
      }
    },
    handleReferralSubmitInfoShow () {
      this.popTipBottomSubmitShow = true
    },
    handleClosePreview () {
      this.$emit('closePreview')
    },
    handleChangeDevice () {
      this.$emit('changeDevice')
    },
    /**
     * 悬浮的推荐 icon
     */
    onReferalIconClick () {
      if (this.isPreview) {
        return
      }
      // 展示推荐按钮 或者 没登录则询问是否是员工
      // 当推荐收费项未开时，点击分享，不需要提问是否是员工
      if (this.hasReferralPermission && (this.showReferralSubmit || !this.accountIsExits)) {
        this.popTipBottomSubmitShow = true
        this.submitReferralConfirmShow = true
        this.submitReferralShareConfirmShow = false
      } else {
        this.submitShareEvent()
      }
    },
    /**
     * 是否员工 - 否
     */
    innerReferralEvent () {
      this.submitReferralConfirmShow = false
      // 不显示提交按钮时直接展示分享弹窗
      if (this.showReferralSubmit) {
        this.submitReferralShareConfirmShow = true
      } else {
        this.submitShareEvent()
      }
    },
    /**
     * 展示分享弹窗
     */
    submitShareEvent () {
      this.popTipBottomSubmitShow = false
      this.showShareAction(false, false)
    },
    referralShareIconClick () {
      // 2024-05-17 更新分享icon逻辑: 页面右上角分享icon的逻辑和页面内点击悬浮的推荐按钮行为一致 (如果没有推荐悬浮的按钮则保持不变)
      if (this.referralIconShow && !this.jobToShowReferral && !this.isInternalJob) {
        this.onReferalIconClick()
      } else if (this.jobToShowReferral && ((this.is_employee_of_company && this.ref_steps_setting.employee_real_budget) || this.ref_steps_setting.non_employee_real_budget)) {
        this.showReferralTipDialog()
      } else {
        this.shareIconClick()
      }
    },
    async shareIconClick () {
      this.$eventBus.$emit('showLoading', true)
      try {
        await this.showShareAction(false, false)
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    shareEmailClick () {
      const referralUrl = this.referral_share_url || this.submitInfoUrl || this.normal_share_url
      if (deviceType.isWeChat) {
        this.closePopupEvent()
        this.referralUrlDialog = {
          title: this.$t('jobDetail.msg.copyUrl'),
          url: referralUrl,
          show: true
        }
      } else {
        window.location.href = `mailto:?body=${encodeURIComponent(referralUrl)}`
      }
    },
    async onCopyReferralUrl () {
      let isSuccess = false
      try {
        await this.$copyText(this.referralUrlDialog.url)
        isSuccess = true
      } catch {
        isSuccess = false
      }
      const messageI18nKey = isSuccess ? 'copySuccess' : 'copyFail'
      const message = this.$t(`jobDetail.message.${messageI18nKey}`)
      this.$toast({ message, position: 'bottom' })
    },
    onCloseReferralUrlDialog () {
      this.referralUrlDialog.show = false
    },
    shareQQClick (e) {
      const shareItme = e.currentTarget
      const shareUrl = 'http://connect.qq.com/widget/shareqq/index.html?'
      this.shareTo(shareItme, shareUrl)
    },
    shareQzoneClick (e) {
      const shareItme = e.currentTarget
      const shareUrl = 'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?'
      this.countShareTimesWithSite('qzone')
      this.shareTo(shareItme, shareUrl)
    },
    shareSinaClick (e) {
      const shareItme = e.currentTarget
      const shareContent = {
        objectUrl: 'http://service.weibo.com/share/share.php?',
        url: encodeURIComponent(this.getShareUrl(shareItme)),
        pic: encodeURIComponent(this.getSharePic()),
        title: encodeURIComponent(this.wechat_share_info.moment_title)
      }
      const shareUrl = shareContent.objectUrl + 'url=' + shareContent.url +
                      '&pic=' + shareContent.pic + '&title=' + shareContent.title
      this.countShareTimesWithSite('sinaminiblog')
      shareItme.href = shareUrl
    },
    shareMessageClick (e) {
      const shareItme = e.currentTarget
      const u = this.shareOgUrl(this.getShareUrl(shareItme), false)
      const shareUrl = 'fb-messenger://share/?link=' + encodeURIComponent(u)
      if (deviceType.isWeChat) {
        alert(this.$t('jobDetail.msg.openInBrowser'))
      } else {
        window.location.href = shareUrl
      }
      return false
    },
    shareWhatappClick (e) {
      const shareItme = e.currentTarget
      const u = this.shareOgUrl(this.getShareUrl(shareItme), false)
      const t = this.share_og_title
      const shareUrl = 'whatsapp://send?text=' + encodeURIComponent(t) + encodeURIComponent('\n\n' + u)
      this.countShareTimesWithSite('whatsapp')
      if (this.is) {
        alert(this.$t('jobDetail.msg.openInBrowser'))
      } else {
        window.location.href = shareUrl
      }
      return false
    },
    shareLinkedinClick (e) {
      const shareItme = e.currentTarget
      const u = this.shareOgUrl(this.getShareUrl(shareItme), true)
      const shareUrl = 'http://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent(u)
      this.countShareTimesWithSite('linkedin')
      shareItme.href = shareUrl
    },
    shareFacebookClick (e) {
      const shareItme = e.currentTarget
      const u = this.shareOgUrl(this.getShareUrl(shareItme), false)
      const shareUrl = 'https://m.facebook.com/sharer.php?u=' + encodeURIComponent(u)
      this.countShareTimesWithSite('facebook')
      shareItme.href = shareUrl
    },
    shareWechatClick (e) {
      this.countShareTimesWithSite('wechat')
      if (deviceType.isWeChat || this.isInJoywok) {
        this.referralTransitionShow = false
        this.wechatShareTipShow = false
        this.maskShow = true
        this.wechatPointerShow = true
        setTimeout(() => {
          this.wechatPointerClick(e)
        }, 3500)
        return
      }
      const referralTransition = this.$refs.transitionShare
      this.maskShow = true
      if (deviceType.isWeChat || this.isInJoywok) {
        this.wechatShareTipShow = true
      }
      this.transitionShow = true
      this.$nextTick(() => {
        referralTransition.querySelector('.detail-link').innerHTML = this.getShareUrl(e.currentTarget)
        this.referralTransitionShow = false
      })
    },
    shareQrcodeClick (e) {
      this.maskShow = true
      this.qrcodeTransitionShow = true
      this.referralTransitionShow = false
      const jobId = this.job.id
      const shareUrl = this.getShareUrl(e.currentTarget)
      this.getJobQrCode({ jobId, shareUrl }).then(resp => {
        if (resp && resp.status === 'success') {
          const preUrl = resp.qr_code + '?_=' + (new Date()).getTime()
          const img = new Image()
          img.src = preUrl
          img.onload = () => {
            this.$refs.qrcodeContent.style.setProperty('background-image', 'url(' + preUrl + ')')
            this.qrcodeAltShow = false
            this.qrcodeContentShow = true
          }
        } else {
          // console.error(resp)
        }
      })
    },
    async onPosterPreviewClick (jobPoster) {
      this.currentPosterShowType = jobPoster.show_type
      this.activePosterShowTypeIndex = _.findIndex(this.posterShowTypes, showType => showType.value === jobPoster.show_type)
      this.currentPopPoster = jobPoster
      if (this.isVideoPoster(jobPoster)) {
        if (!jobPoster.videoKeyAfterCompound) {
          this.isGeneratingVideo = true
        }
      }
      if (!jobPoster.bgImageSrc) {
        this.painting = {}
        await this.generateBgImage(jobPoster)
      }

      // let jw = window.jw
      // if (this.isInJoywok && !jw) {
      //   await require('https://www.joywok.com/public/scripts/jssdk.js')
      //   jw = window.jw
      // }
      if (this.isInJoywok && !this.isVideoPoster(jobPoster)) {
        // 仅图片预览与下载，视频预览下载逻辑在生成视频后处理
        if (!jobPoster.bgImageSrc) {
          return
        }

        // const fileKey = generateJobDetailPosterFileKey(this.shortId)
        // await uploadBase64Src(fileKey, jobPoster.bgImageSrc)
        // const posterImgPath = getFilePath(fileKey)

        // jw.previewImages({
        //   current: posterImgPath,
        //   urls: [posterImgPath],
        //   enableSave: 1,
        //   enableShare: 1
        // })
        // jw.playVideo({
        //   'video_url': this.getSourcePath(jobPoster.bg_source_url),
        //   'cover_image': jobPoster.posterShareImg,
        //   'allow_download': 1,
        //   'allow_operate': 1
        // }, {
        //   success: function (res) {},
        //   fail: function (res) {}
        // })
      } else {
        this.maskShow = true
        this.posterTransitionShow = true
        this.hiddenChatbot = true
        this.wechatShareTipShow = false
        this.saveImgTipShow = true
        this.referralTransitionShow = false
        if (!this.isVideoPoster(jobPoster)) {
          this.posterImgUrl = this.currentPopPoster.bgImageSrc
        }
        // setTimeout(() => {
        //   const videoRef = this.$refs['poster-video']
        //   videoRef.src = this.getSourcePath(jobPoster.bg_source_url)
        // }, 200)
      }
      this.countShareTimesWithSite('wechat')
    },
    shareTransitonClose () {
      if (this.$refs['poster-video']) {
        this.$refs['poster-video'].pause()
      }
      this.activePosterShowTypeIndex = 0
      this.transitionShow = false
      this.qrcodeTransitionShow = false
      this.maskShow = true
      this.qrcodeAltShow = true
      this.qrcodeContentShow = false
      this.posterTransitionShow = false
      this.saveImgTipShow = false
      this.hiddenChatbot = false
      this.referralTransitionShow = true
      if (deviceType.isWeChat || this.isInJoywok) {
        this.wechatShareTipShow = false
      }
    },
    shareOgUrl (shareUrl, needTs) {
      const lang = this.languageCode
      const langParam = shareUrl.indexOf('?') !== -1 ? '&lang=' + lang : '?lang=' + lang
      const tsParam = needTs ? '&ts=' + new Date().getTime() : ''
      return shareUrl + langParam + tsParam
    },
    shareTo (shareItme, shareUrl) {
      const shareContent = {
        url: this.getShareUrl(shareItme),
        desc: '', // _getShareJob()
        title: this.getShareCompanyName(),
        summary: this.job.i18n_name.trim(),
        pics: this.getSharePic(),
        site: 'Ajinga' /* 分享来源(可选) 如：QQ分享 */
      }
      const s = []
      for (const i in shareContent) {
        s.push(i + '=' + encodeURIComponent(shareContent[i] || ''))
      }
      shareItme.href = shareUrl + s.join('&')
    },
    countShareTimesWithSite (site) {
      const jobId = this.job.id
      this.countShareTimes({ job_id: jobId, channel: site })
    },
    getShareUrl (e) {
      let shareUrl
      if (e && e.classList.contains('referral-share')) {
        // if (e.classList.contains('share-wechat') || e.classList.contains('share-qrcode')) {
        //   this.maskShow = false
        //   this.referralTransitionShow = false
        //   if (this.isWechatBrowser) {
        //     this.wechatShareTipShow = false
        //   }
        // }
        shareUrl = this.referral_share_url
      } else if (e && e.classList.contains('submit-share')) {
        shareUrl = this.submitInfoUrl
      } else {
        shareUrl = this.normal_share_url || location.href
      }

      if (e && (e.classList.contains('share-wechat') || e.classList.contains('share-qrcode'))) {
        this.wechatShareTipShow = false
      }

      return shareUrl
    },
    getShareCompanyName () {
      let companyName = this.job.company.i18n_name
      if (companyName) {
        return companyName.trim()
      } else {
        if (this.languageCode === 'en') {
          companyName = this.company.name
        } else {
          companyName = this.company.cn_name
        }
        return companyName.trim()
      }
    },
    getSharePic () {
      const baseUrl = location.protocol + '//' + location.hostname
      const companyImg = this.$refs.referralTransitionCompanyImg
      if (companyImg) {
        return baseUrl + companyImg.src
      } else {
        return baseUrl + this.$refs.jobContentCompanyImg.src
      }
    },
    wechatPointerClick (e) {
      e.stopPropagation()
      this.wechatPointerShow = false
      this.maskShow = false
    },
    applyDirectlyNeedStatement (e, applyBtn) {
      if (this.isPreview) {
        return
      }
      if (!applyBtn && e) {
        applyBtn = e.currentTarget
      }
      if (!applyBtn) {
        return
      }
      const jobGroupTip = this.$refs.singleJobGroupTip
      if (applyBtn.classList.contains('need-statement')) {
        this.showStatement = true
        return false
      } else if (applyBtn.classList.contains('need-statement-2')) {
        const commonTosCheckError = this.$refs.commonTosCheckError
        if (!this.agreePolicy) {
          commonTosCheckError.classList.remove('hide')
          commonTosCheckError.parentElement.style.display = 'block'
          this.chatbotClickApplyJobButton(this.job.id)
          return false
        }
        if (!this.personalAgreementStatus?.is_agreed_system_policy) {
          this.showStatement = true
          return false
        }
        if (jobGroupTip && !jobGroupTip.classList.contains('show')) {
          jobGroupTip.classList.add('show')

          this.maskShow = true
          this.singleJobGroupPopupShow = true
          return false
        }
        const applyUrl = this.applyDirectlyUrl
        window.location.href = `${applyUrl}${applyUrl.includes('?') ? '&' : '?'}agreed_policy_items=${this.companyPolicyInfo.link[0].id}`
        return false
      } else if (!applyBtn.classList.contains('need-statement-2') && !applyBtn.classList.contains('need-statement')) {
        if (document.querySelector('#henkel_tos_check')) {
          const tosCheckBox = document.querySelector('#henkel_tos_check')
          const policyCheck = document.querySelector('#henkel_policy_check')
          if (!tosCheckBox.checked || !policyCheck.checked) {
            // policyCheck.parentNode.querySelector('#tos_check_error').style.display = 'block'
            this.tosCheckErrorShow = true
            return false
          }
        }
        if (jobGroupTip && !jobGroupTip.classList.contains('show')) {
          jobGroupTip.classList.add('show')
          this.maskShow = true
          this.singleJobGroupPopupShow = true
          return false
        }

        // for henkel agreements
        if (this.$refs.henkelAgm1Check) {
          const jobId = this.job.id
          const agm1CheckBox = this.$refs.henkelAgm1Check
          if (!agm1CheckBox.checked) {
            this.tosCheckErrorShow = true
          } else {
            this.henkelAgm2PopupShow = true
          }
          this.chatbotClickApplyJobButton(jobId)
          return false
        } else {
          if (!applyBtn.classList.contains('disabled')) {
            const nextHref = this.applyDirectlyUrl
            window.location.href = nextHref
          }
        }
        return false
      }
    },
    singleJobGroupPopupClose () {
      this.maskShow = false
      this.singleJobGroupPopupShow = false
      this.$refs.singleJobGroupTip.classList.remove('show')
    },
    singleJobGroupPopupCloseContinue () {
      this.applyDirectlyNeedStatement(this.$refs.applyDirectly)
    },
    submitResume () {
      const jobId = this.job.id
      let url = '/referral/earn-rewards/' + jobId + '/'
      const referId = this.quick_referral_id
      if (referId) {
        url = url + referId + '/'
      }
      // let showPolicyPopupData = 0
      if (this.showPolicyPopup) {
        // showPolicyPopupData = 1
      }
      this.getReferralEarnRewards(url).then(res => {
        // const backUrl = `/job-description/${this.shortId}/?go_to_submit=0&show_policy_popup=${showPolicyPopupData}`
        // const url = '/recruiting/personal/referral/submit/resume'
        // this.$router.replace({ path: url, query: { job_id: this.jobId, backUrl: backUrl } })
        const url = `/recruiting/personal/referral/submit/resume?job_id=${jobId}&back=${encodeURIComponent(location.href)}&company_id=${this.company.id}`
        window.location.href = url
      })
    },
    getY (dom) {
      const y = window.getComputedStyle(dom, null).getPropertyValue('background-position-y')
      return parseInt(y.replace('%', ''))
    },
    showCustomRewardsRuleDownClick (e) {
      const max = 100
      const step = 20
      const main = this.$refs.jobDetailRewardsMain
      const currentY = this.getY(main)
      if (currentY + step >= max) {
        main.style.setProperty('background-position-y', max + '%')
        e.currentTarget.classList.add('disable')
      } else {
        main.style.setProperty('background-position-y', currentY + step + '%')
        e.currentTarget.classList.remove('disable')
      }
      this.$refs.showCustomRewardsRuleUp.classList.remove('disable')
    },
    showCustomRewardsRuleUpClick (e) {
      const step = 20
      const min = 0
      const main = this.$refs.jobDetailRewardsMain
      if (main) {
        const currentY = this.getY(main)
        if (currentY - step <= min) {
          main.style.setProperty('background-position-y', min + '%')
          e.currentTarget.classList.add('disable')
        } else {
          main.style.setProperty('background-position-y', currentY - step + '%')
          e.currentTarget.classList.remove('disable')
        }
      }

      this.$refs.showCustomRewardsRuleDown.classList.remove('disable')
    },
    showRewardsRule (e) {
      this.popTipBottomInfoShow = false
      this.popTipBottomSubmitShow = false
      this.reviewPopShow = true
      document.querySelector('body').style.overflow = 'hidden'
      const main = this.$refs.jobDetailRewardsMain
      if (main) {
        main.style.setProperty('background-position-y', '0px')
      }

      e.stopPropagation()
      return false
    },
    henkelScrollUp () {
      const scrollElem = this.$refs.henkelAgm2PopupContentText
      scrollElem.scrollTop = scrollElem.scrollTop - 100
    },
    henkelScrollDown () {
      const scrollElem = this.$refs.henkelAgm2PopupContentText
      scrollElem.scrollTop = scrollElem.scrollTop + 100
    },
    showReferralTipDialog () {
      if (this.isPreview) {
        return
      }
      const submitReferral = this.submit_referral
      if (submitReferral) {
        this.popTipBottomSubmitShow = true
      } else {
        this.popTipBottomInfoShow = true
      }
    },
    henkelAgreementPopBoxEvent (e, status) {
      let henAgm1 = ''
      let henAgm2 = ''
      const checkbox = this.$refs.henkelAgm1Check
      if (checkbox.checked) {
        henAgm1 = this.hen_agm1
        henAgm2 = this.hen_agm2
        const henAgm2Status = status
        let applyHref = this.applyDirectlyUrl
        if (applyHref.indexOf('?') >= 0) {
          applyHref += '&hen_agm1=' + henAgm1 + '&hen_agm2=' + henAgm2 + '&hen_agm2_status=' + henAgm2Status
        } else {
          applyHref += '?hen_agm1=' + henAgm1 + '&hen_agm2=' + henAgm2 + '&hen_agm2_status=' + henAgm2Status
        }
        window.location.href = applyHref
      }
      return false
    },
    onEarnRewardsNowClick () {
      this.popTipBottomInfoShow = false
      this.showShareAction(false, false)
    },
    savePreviewQRcodeUrl (url, id) {
      if (this.qrCodePromise && this.qrCodePromiseResolve) {
        this.qrCodePromiseResolve()
      }
      this.posterQrcode.url = url
    },
    generateFileKey (language, type) {
      const fileKeyPrefix = 'job-poster/'
      const accountId = this.account.id || this.softUser?.id || `noaccount${parseInt(Math.random() * 1000)}`
      return `${fileKeyPrefix}${this.company.id}-${accountId}-${language}-${type}-${new Date().valueOf()}`
    },
    async handleVideoCompound (previewImageSrc, jobPoster) {
      const lang = this.languageCode === 'en' ? 'en' : 'cn'
      const imageFileKey = this.generateFileKey(lang, 'uservideoimage')
      const imageWidth = jobPoster.bg_size.X
      const imageHeight = jobPoster.bg_size.Y
      const videoPosterType = jobPoster.watermark_bg_location
      const videoInfo = jobPoster.videoInfo
      const videoFileKey = jobPoster.bg_source_url
      if (!videoFileKey) {
        return
      }
      if (videoPosterType === 'tail') {
        const displayAspectRatio = videoInfo.displayAspectRatio
        const aspectHeight = getBindImageHeight(displayAspectRatio, imageWidth, imageHeight)
        const resizeSrcFile = await dataUrlToFile(previewImageSrc, 'test')
        // 压缩预处理图片，否则图片拼接视频不成功
        const blob = await preCompressImage(resizeSrcFile, imageWidth, aspectHeight)
        await uploadFile(blob, imageFileKey)
      } else {
        const resizeSrc = await resizeDataURL(previewImageSrc, imageWidth, imageHeight)
        await uploadBase64Src(imageFileKey, resizeSrc)
      }
      // 调后台接口, 传imageFileKey, videoFileKey, videoPosterType, 后台调七牛接口合成视频, 将合成后的视频url传给前台并显示。
      const params = {
        imageKey: imageFileKey,
        videoKey: videoFileKey,
        resolution: videoInfo,
        location: videoPosterType,
        posterUniqueKey: this.getVideoPosterUniqueKey(jobPoster)
      }
      const resp = await this.watermarkVideo(params)
      const { persistentId, lastUrl } = resp
      if (persistentId) {
        this.getVideoStatus(persistentId, imageFileKey, jobPoster)
      } else if (lastUrl) {
        jobPoster.videoKeyAfterCompound = lastUrl
        this.isGeneratingVideo = false
      }
    },
    getVideoStatus (persistentId, imageKey, jobPoster) {
      setTimeout(async () => {
        const posterUniqueKey = this.getVideoPosterUniqueKey(jobPoster)
        const params = {
          persistentId,
          posterUniqueKey
        }
        const resp = await this.getMediaPrefopStatus(params)
        if (resp.code > 2) {
          this.$message({
            type: 'error',
            showClose: true,
            message: this.$t(`${this.jobPosterI18nPrefix}.message.operateFailed`)
          })
          this.isGeneratingVideo = false
          return
        }
        if (resp.code !== 0) {
          this.getVideoStatus(persistentId, imageKey, jobPoster)
          return
        }
        if (resp?.items.length > 0) {
          const newVideoKey = resp.items[0].key
          jobPoster.videoKeyAfterCompound = newVideoKey
          this.isGeneratingVideo = false
          imageKey && this.batchDeletePosterImage({ invalid_keys: [imageKey] })
        }
      }, 2000)
    },
    getSourcePath (path) {
      if (!path || path.includes('http')) {
        return path
      } else {
        return `${process.env.VUE_APP_QINIU_DOMAIN}${path}?v=${new Date().getTime()}`
      }
    },
    isVideoPoster (jobPoster) {
      return jobPoster && jobPoster.poster_type === 'video'
    },

    getPosterContainerWidth (jobPoster, posterCount) {
      const containerWidth = 0.45
      // if (posterCount === 1 && this.isVideoPoster(jobPoster)) {
      //   containerWidth = 0.9
      // }
      return containerWidth
    },

    getVideoHeight (jobPoster, videoWidthPercent = 0.9) {
      const videoInfo = jobPoster.videoInfo
      if (!videoInfo) {
        return ''
      }
      const width = videoInfo.width
      const height = videoInfo.height
      if (!width || !height) {
        return ''
      }
      const screenWidth = document.body.clientWidth
      const imageWidth = screenWidth * videoWidthPercent
      const imageHeight = imageWidth * height / width
      return `${imageHeight}px`
    },

    checkUrlIsValid (url) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.src = url
        img.onload = (res) => {
          resolve(true)
        }
        img.onerror = () => {
          resolve(false)
        }
      })
    },
    getPosterQrcodeUrl (path) {
      let url = null
      if (path.indexOf('?') === -1) {
        url = path + '?aj_source=JDpage&aj_code=Jobposter'
      } else {
        const strList = path.split('?')
        const params = strList[1].split('&')
        url = strList[0]
        url += '?aj_source=JDpage&aj_code=Jobposter'
        params.forEach(item => {
          if (item.indexOf('aj_source') === -1 && item.indexOf('aj_code') === -1) {
            url += '&'
            url += item
          }
        })
      }
      return url
    },
    addJobPosterByShowType (showType, jobPoster) {
      if (showType === JOB_POSTER_SHOW_TYPE.COMMON) {
        this.commonPosterList.push(jobPoster)
      } else if (showType === JOB_POSTER_SHOW_TYPE.CUSTOM) {
        this.customPosterList.push(jobPoster)
      } else if (showType === JOB_POSTER_SHOW_TYPE.INSTRUCTIONS) {
        this.instructionsPosterList.push(jobPoster)
      } else {
        this.ambassadorPosterList.push(jobPoster)
      }
    },
    async loadJobPosterList (link) {
      this.posterListData = []
      this.commonPosterList = []
      this.customPosterList = []
      this.instructionsPosterList = []
      this.ambassadorPosterList = []
      const languageCode = this.languageCode === 'en' ? 'en' : 'cn'
      const posterResp = await this.getJobDetailJobPoster({ company_id: this.company.id, language_code: languageCode })
      const jobPosters = posterResp.job_poster_list
      if (!jobPosters || !jobPosters.length) {
        this.showJobPoster = false
        return
      }
      this.showJobPoster = true
      let imagePosterCount = 0
      let videoPosterCount = 0
      for (const jobPoster of jobPosters) {
        jobPoster.bg_size = JSON.parse(jobPoster.bg_size)
        jobPoster.content_configuration = JSON.parse(jobPoster.content_configuration)
        jobPoster.qrcode_configuration = JSON.parse(jobPoster.qrcode_configuration)
        const showType = jobPoster.show_type
        if (showType === 'AMBASSADOR_POSTER' && jobPoster.poster_type === 'video') {
          let posterShareImg = '@/assets/image/jobDetail/StuxShareImage.png'
          if (jobPoster.share_img_url) {
            posterShareImg = `${process.env.VUE_APP_QINIU_DOMAIN}${jobPoster.share_img_url}?vframe/jpg/offset/0`
          }
          jobPoster.posterShareImg = posterShareImg
        } else {
          jobPoster.posterShareImg = jobPoster.share_img_url ? this.getSourcePath(jobPoster.share_img_url) : '@/assets/image/jobDetail/StuxShareImage.png'
        }
        jobPoster.posterQrcode = {
          text: this.getPosterQrcodeUrl(link)
        }
        if (jobPoster.qrcode_configuration.haveLogo) {
          const urlState = await this.checkUrlIsValid(this.$DjangoBaseUrl(this.company.logo))
          if (urlState) {
            jobPoster.posterQrcode.logoSrc = this.$DjangoBaseUrl(this.company.logo)
          } else {
            jobPoster.posterQrcode.logoSrc = require('@/assets/image/jobDetail/blank-logo.png')
          }
          // this.posterQrcode.logoSrc = jobPoster.posterQrcode.logoSrc
        }
        if (jobPoster.poster_type === 'img') {
          this.posterListData.push(jobPoster)
          this.addJobPosterByShowType(showType, jobPoster)
          if (imagePosterCount === 1) {
            continue
          }
          // await this.generateBgImage(jobPoster)
          imagePosterCount += 1
        } else if (jobPoster.poster_type === 'video') {
          jobPoster.originVideoSrc = this.getSourcePath(jobPoster.bg_source_url)
          jobPoster.poster_unique_key = this.generateVideoPosterUniqueKey(jobPoster)
          jobPoster.videoInfo = {}
          try {
            const resp = await this.getMediaInfo(jobPoster.bg_source_url)
            if (resp?.streams.length > 0) {
              const newVideoInfo = resp.streams[0]
              jobPoster.videoInfo = {
                width: newVideoInfo.width,
                height: newVideoInfo.height,
                displayAspectRatio: newVideoInfo.display_aspect_ratio || `${newVideoInfo.width.toString()}/${newVideoInfo.height.toString()}`
              }
            }
          } catch {
          }
          this.posterListData.push(jobPoster)
          this.addJobPosterByShowType(showType, jobPoster)
          if (videoPosterCount === 1) {
            continue
          }
          videoPosterCount += 1
        }
      }
      if (this.isAmbassador) {
        this.posterListData = _.take(_.filter(this.posterListData, item => item.show_type !== 'AMBASSADOR'), 2)
      } else {
        this.posterListData = _.take(_.filter(this.posterListData, item => item.show_type === 'COMMON'), 2)
      }
      if (!this.posterListData.length) {
        this.showJobPoster = false
      }
    },
    async showShareBox (link) {
      if (this.hasClickShare) {
        return
      }
      this.hasClickShare = true
      if (this.is_have_job_poster && !this.posterListData.length) {
        await this.loadJobPosterList(link)
      }
      this.referralTransitionShow = true
      this.maskShow = true
      this.hiddenChatbot = true
      if (deviceType.isWeChat || this.isInJoywok) {
        this.wechatShareTipShow = true
      }
      this.hasClickShare = false
    },
    // TODO 未来如果多视频海报，这里需要修改
    getVideoPosterUniqueKey (jobPoster) {
      // const videoPoster = this.posterListData.filter(item => item.poster_type === 'video')
      const posterUniqueKey = jobPoster.poster_unique_key
      return posterUniqueKey
    },
    // 用于后台缓存同一用户对同一职位的合成视频
    generateVideoPosterUniqueKey (jobPoster) {
      const bgSourceUrl = jobPoster.bg_source_url
      const bgSize = jobPoster.bg_size
      const contentConfiguration = jobPoster.content_configuration
      const qrcodeUrl = jobPoster.posterQrcode.text
      const qrcodeConfiguration = jobPoster.qrcode_configuration
      const watermarkBgLocation = jobPoster.watermark_bg_location
      const watermarkBgUrl = jobPoster.watermark_bg_url
      const jobName = this.job.i18n_name
      const jobCity = this.job.cities
      const jobCompany = this.company.i18n_name
      const allInfo = {
        bgSourceUrl,
        bgSize,
        contentConfiguration,
        qrcodeUrl,
        qrcodeConfiguration,
        watermarkBgLocation,
        watermarkBgUrl,
        jobName,
        jobCity,
        jobCompany
      }
      return md5(JSON.stringify(allInfo))
    },
    async changeCurrentPoster (jobPoster) {
      // 正在生成图片时不可切换
      if (this.isGeneratingBgImagePosterId) {
        return
      }
      if (jobPoster.id === this.currentPopPoster.id && this.currentPopPoster.ambassador_poster_id === jobPoster.ambassador_poster_id && this.posterTransitionShow) {
        return
      }
      this.currentPopPoster = jobPoster
      if (jobPoster.bgImageSrc && !this.isVideoPoster(jobPoster)) {
        this.posterImgUrl = jobPoster.bgImageSrc
        return
      }
      this.onPosterPreviewClick(jobPoster)
    },
    async generateBgImage (jobPoster) {
      const posterId = this.currentPosterShowType === 'AMBASSADOR_POSTER' ? 'ambassador_poster_id' : 'id'
      this.isGeneratingBgImagePosterId = _.get(jobPoster, posterId)
      this.posterQrcode.logoSrc = jobPoster.posterQrcode.logoSrc
      if (jobPoster.posterQrcode.text) {
        this.posterQrcode.text = jobPoster.posterQrcode.text
      }
      this.qrCodePromise = new Promise((resolve, reject) => {
        this.qrCodePromiseResolve = resolve
      })
      this.posterPaintingPromise = new Promise((resolve, reject) => {
        this.posterPaintingPromiseResolve = resolve
        const painting = {
          width: (jobPoster.bg_size.X | 1) + 'px',
          height: (jobPoster.bg_size.Y | 1) + 'px',
          background: this.getSourcePath(this.isVideoPoster(jobPoster) ? jobPoster.watermark_bg_url : jobPoster.bg_source_url),
          views: []
        }

        jobPoster.content_configuration.forEach(item => {
          if (item.data.status) {
            let fontFamily = item.data.font
            if (item.data.customFont) {
              /**
               *  vue-canvas-poster组件中的fontFamily的值只支持设置单个
               *  去除自定义字体前后的 " 使该组件支持多个fontFamily
               *  例如： vue-canvas-poster组件中fontFamily的应用为 font: 12px "{fontFamily}"
               *      若 fontFamily = "宋体", "Arial", "sans-serif" 则 => font: 12px ""宋体", "Arial", "sans-serif"" 不符合规则
               */
              fontFamily = this.getCustomFontFromTheme()?.slice(1, -1)
            }
            const viewItem = {
              type: 'text',
              css: {
                left: (item.data.X | 0) + 'px',
                top: (item.data.Y | 0) + 'px',
                fontSize: (item.data.size | 0) + 'px',
                lineHeight: (item.data.size | 0) + 6 + 'px',
                fontFamily: fontFamily,
                fontWeight: item.data.fontBold,
                width: (item.data.MaxWidth | 0) + 'px',
                color: item.data.color,
                textAlign: item.data.centerAlign ? 'center' : 'left',
                maxLines: 2
              }
            }
            if (item.name === 'jobName') {
              const textArray = this.handlLineBreak(item, this.job.i18n_name, fontFamily)
              if (textArray.length > 1) {
                const viewItem1 = {
                  type: 'text',
                  text: textArray[0],
                  css: {
                    left: (item.data.X | 0) + 'px',
                    top: (item.data.Y | 0) + 'px',
                    fontSize: (item.data.size | 0) + 'px',
                    lineHeight: (item.data.size | 0) + 6 + 'px',
                    fontFamily: fontFamily,
                    fontWeight: item.data.fontBold,
                    width: (item.data.MaxWidth | 0) + 'px',
                    textAlign: item.data.centerAlign ? 'center' : 'left',
                    color: item.data.color,
                    maxLines: 1
                  }
                }
                const viewItem2 = {
                  type: 'text',
                  text: textArray[1],
                  css: {
                    left: (item.data.X | 0) + 'px',
                    top: (item.data.Y | 0) + (item.data.size | 0) + 6 + 'px',
                    fontSize: (item.data.size | 0) + 'px',
                    lineHeight: (item.data.size | 0) + 6 + 'px',
                    fontFamily: fontFamily,
                    fontWeight: item.data.fontBold,
                    width: (item.data.MaxWidth | 0) + 'px',
                    textAlign: item.data.centerAlign ? 'center' : 'left',
                    color: item.data.color,
                    maxLines: 1
                  }
                }
                painting.views.push(viewItem1)
                painting.views.push(viewItem2)
              } else {
                viewItem.css.maxLines = 2
                viewItem.text = this.job.i18n_name
                painting.views.push(viewItem)
              }
            } else if (item.name === 'city') {
              if (this.job.cities.length === 1) {
                viewItem.text = this.job.cities[0].name
              } else if (this.job.cities.length > 1) {
                viewItem.text = this.$t('jobDetail.moreCity', { city1: this.job.cities[0].name, city2: this.job.cities[1].name })
              } else {
                viewItem.text = ''
              }
              viewItem.css.maxLines = 1
              painting.views.push(viewItem)
            } else if (item.name === 'companyName') {
              viewItem.css.maxLines = 1
              viewItem.text = this.company.i18n_name
              painting.views.push(viewItem)
            } else if (item.name === 'distinct') {
              if (this.job.distinct.length === 1) {
                viewItem.text = this.job.distinct[0]
              } else if (this.job.distinct.length > 1) {
                viewItem.text = this.$t('jobDetail.moreDistinct', { distinct1: this.job.distinct[0], distinct2: this.job.distinct[1] })
              } else {
                viewItem.text = ''
              }
              viewItem.css.maxLines = 1
              painting.views.push(viewItem)
            } else if (item.name === 'address') {
              if (this.job.address.length === 1) {
                viewItem.text = this.job.address[0]
              } else if (this.job.address.length > 1) {
                viewItem.text = this.job.address[0] + this.$t('jobDetail.moreAddress')
              } else {
                viewItem.text = ''
              }
              viewItem.css.maxLines = 1
              painting.views.push(viewItem)
            }
          }
        })

        // add qrcode
        const qrcodeConfiguration = jobPoster.qrcode_configuration
        this.qrcodeQid += 1
        return this.qrCodePromise.then(() => {
          const qrcodeView = {
            type: 'image',
            url: this.posterQrcode.url,
            css: {
              width: (qrcodeConfiguration.width | 0) + 'px',
              height: (qrcodeConfiguration.width | 0) + 'px',
              left: (qrcodeConfiguration.X | 0) + 'px',
              top: (qrcodeConfiguration.Y | 0) + 'px'
            }
          }
          if (qrcodeConfiguration.roundedCorners) {
            qrcodeView.css.borderRadius = Number(qrcodeConfiguration.width | 0) * 0.05 + 'px'
          }
          painting.views.push(qrcodeView)
          this.painting = painting
        })
      })

      return Promise.all([this.qrCodePromise, this.posterPaintingPromise])
    },

    generatePosterVideo (jobPoster) {
      if (this.isGeneratingVideo) {
        this.$message.info({
          message: this.$t('jobDetail.videoIsGenerating'),
          customClass: 'message-override'
        })
        return
      }
      if (!jobPoster.videoKeyAfterCompound) {
        this.currentPopPoster = jobPoster
        this.isGeneratingVideo = true
        this.generateBgImage(jobPoster)
        return
      }
      this.downloadVideoByKey(jobPoster.videoKeyAfterCompound)
    },
    async downloadVideoByKey (key) {
      if (deviceType.isWeChat) {
        this.$router.push(`/recruiting/resource-download?type=video&key=${key}&source=VIDEO_POSTER`)
        return
      }
      const src = `${this.getSourcePath(key)}&attname=${new Date().getTime()}.mp4`
      if (!this.isInJoywok) {
        // window.open(src, '_blank')
        window.location.href = src
        // return
      }
      // const downloadSrc = this.getSourcePath(key)
      // let jw = window.jw
      // if (!jw) {
      //   await require('https://www.joywok.com/public/scripts/jssdk.js')
      //   jw = window.jw
      // }
      // jw.downloadVideo({
      //   video_url: downloadSrc
      // }, {
      //   success: function (res) {},
      //   fail: function (res) {}
      // })
    },

    closeDownloadTip () {
      this.showiOSWechatDownloadTip = false
      this.showiOSWechatDownloadTipByTipButton = false
    },

    onVideoLoaded () {
      const videoRef = this.$refs['poster-video']
      videoRef && videoRef.pause()
    },

    handlLineBreak (item, text, fontFamily) {
      const textArray = []
      const strList = text.split(' ')
      if (strList.length === 1) {
        return strList
      }
      const maxWidth = item.data.MaxWidth | 0
      if (maxWidth === 0) {
        textArray[0] = text
        return textArray
      }
      const divEl = document.createElement('div')
      divEl.style.position = 'absolute'
      divEl.style.left = '-99999px'
      divEl.style.lineHeight = (item.data.size | 0) + 6 + 'px'
      divEl.style.fontWeight = item.data.fontBold
      divEl.style.fontSize = (item.data.size | 0) + 'px'
      divEl.style.fontFamily = fontFamily
      if (item.data.fontBold) {
        divEl.style.fontWeight = 'bold'
      }
      document.body.appendChild(divEl)
      let lastTextlength = 0 // 上一次截取的位置
      let noShowStr = text // 未被截取的字符串
      for (let i = 0; i < strList.length; i++) {
        const substrIndex = noShowStr.indexOf(strList[i]) + strList[i].length
        const innerText = text.substring(0, lastTextlength + substrIndex)
        noShowStr = text.substring(lastTextlength + substrIndex)
        divEl.innerText = innerText
        if (divEl.clientWidth > maxWidth) {
          // 当前长度大于max时，最后加的子串是全英文或者全数字时，取上一次截取结果作为第一行。
          const isEnglishWorld = /^[a-zA-Z]|\d+$/.test(strList[i])
          const isSpecialChar = /^[^%&',;=?$\x22]+$/.test(strList[i])
          if (i === 0) {
          } else if (isEnglishWorld || isSpecialChar) {
            textArray[0] = text.substring(0, lastTextlength)
            textArray[1] = text.substring(lastTextlength).trim()
          } else {
            textArray[0] = text
          }
          divEl.remove()
          return textArray
        }
        lastTextlength = lastTextlength + substrIndex
      }
      divEl.remove()
      textArray[0] = text
      return textArray
    },
    formatShareUrl (url) {
      let shareUrl = location.origin + url
      if (this.normal_share_url.includes('?')) {
        const urlParmsStr = this.normal_share_url.split('?')
        const pammStr = urlParmsStr[1]
        _.forEach(pammStr[1].split('&'), item => {
          if (['aj_source', 'aj_code'].includes(item)) {
            if (shareUrl.includes('?')) {
              shareUrl = shareUrl + '&' + item
            } else {
              shareUrl = shareUrl + '?' + item
            }
          }
        })
      }
      return shareUrl
    },
    async showShareAction (isShareDirectly, isSetWxReferUrl) {
      let referUrl = this.referral_share_url
      const account = this.account
      const softUser = this.softUser
      if (referUrl) {
        if (!referUrl.includes('http')) {
          referUrl = location.origin + referUrl
          this.referral_share_url = referUrl
          this.wxShareUrl = this.referral_share_url
        }
        if (!isShareDirectly && !isSetWxReferUrl) {
          await this.showShareBox(referUrl)
        }
        return
      }
      const jobId = this.job.id
      let url = '/referral/earn-rewards/' + jobId + '/'
      const referId = this.referId
      if (referId && referId !== 'None') {
        url = url + referId + '/'
      }
      if (account?.id || softUser?.id) {
        const res = await this.getReferralEarnRewards(url)
        if (res.status === 'success') {
          if (res.refer_url) {
            referUrl = this.formatShareUrl(res.refer_url)
            this.referral_share_url = referUrl
            this.wxShareUrl = referUrl
            if (!isShareDirectly && !isSetWxReferUrl) {
              await this.showShareBox(referUrl)
            }
          }
        } else {
          await this.showShareBox(this.normal_share_url)
        }
      } else {
        await this.showShareBox(this.normal_share_url)
      }
    },
    hideLocations () {
      const jobLocationCount = this.jobLocationList.length
      let containerHeight
      let itemHeight
      const width = window.innerWidth
      const height = window.innerHeight
      if (width < 768) { // pad width
        containerHeight = height - 55 - 5
        itemHeight = 39
      } else {
        containerHeight = height - 111 - 10
        itemHeight = 76
      }
      const listHeight = jobLocationCount <= 4 ? jobLocationCount * itemHeight : 3.5 * itemHeight
      let mapHeight = containerHeight - listHeight
      mapHeight += 50
      // if (!this.has_custom_mobile_landing_page) {
      //   const navBarHeight = document.querySelector('.navBar .holder').clientHeight
      //   this.$refs.jdMapContainer.style.top = navBarHeight + 'px'
      // }
      this.$refs.jdMapContainer.style.height = containerHeight + 'px'

      this.mapContainerParams.mapHeight = mapHeight
      this.mapContainerParams.listHeight = listHeight
      this.mapContainerParams.itemHeight = itemHeight
    },
    getJobLocationsByLatLng () {
      const jobInfo = {}
      if (this.mapContainerParams.lng && this.mapContainerParams.lat) {
        jobInfo.lng = this.mapContainerParams.lng
        jobInfo.lat = this.mapContainerParams.lat
      }
      const jobId = this.job.id
      this.locationLoadPromise = this.getJobLocations({ jobId, jobInfo }).then(resp => {
        if (resp && resp.length) {
          this.showLoadingIcon = false
          this.jobLocationList = resp
        }
        this.hideLocations()
      })
    },
    viewMoreLocationEvent (e) {
      const btn = e.currentTarget
      const jobLocations = document.querySelectorAll('#job-detail-information-contanier .locations li')
      if (btn.classList.contains('unfold')) {
        btn.classList.remove('unfold')
        jobLocations.forEach(item => {
          if (item.dataset.index > 4) { // to do 滑动效果
            item.style.display = 'none'
          }
        })
      } else {
        btn.classList.add('unfold')
        jobLocations.forEach(item => {
          item.style.display = 'list-item'
          if (item.dataset.index < 4) { // to do 滑动效果

          }
        })
      }
    },
    initJobLocations (callback) {
      navigator.geolocation.getCurrentPosition(position => {
        this.mapContainerParams.lng = position.coords.longitude
        this.mapContainerParams.lat = position.coords.latitude
        callback()
      }, () => {
        callback()
      }, {
        enableHighAccuracy: true,
        maximumAge: 5000,
        timeout: 1000
      })
    },
    async renderLocationMap () {
      if (!this.showMapContainer || this.mapHasInit) {
        return
      }
      this.mapLoading = true
      try {
        if (!this.mapLoader) {
          this.mapLoader = getAMap(undefined, 1.3)
        }
        await Promise.all([
          this.locationLoadPromise,
          this.mapLoader
        ])
        this.hideLocations()
        this.mapInitialize()
        this.mapHasInit = true
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err)
        this.$message.error(this.$t('common.message.mapLoadFail'))
        this.onBackBtnIconClick()
        this.mapLoader = null
        this.mapHasInit = false
      } finally {
        this.mapLoading = false
      }
    },
    async mapInitialize () {
      this.$refs.mapContainerTest.style.setProperty('height', this.mapContainerParams.mapHeight + 'px')
      this.$refs.locationList.style.setProperty('height', this.mapContainerParams.listHeight + 'px')

      const lang = (navigator.language.indexOf('zh') === -1 ? 'en' : 'zh_cn')
      if (this.mapContainerParams.lat && this.mapContainerParams.lng) {
        this.lng = this.mapContainerParams.lng
        this.lat = this.mapContainerParams.lat
      }
      if (this.mapObj) {
        this.mapObj.destroy()
      }
      const AMap = await this.mapLoader
      this.mapObj = new AMap.Map('map-container', {
        view: new AMap.View2D({
          center: new AMap.LngLat(this.lng, this.lat),
          zoom: 16,
          rotation: 0
        }),
        lang: lang
      })
    },
    backJobList () {
      const backUrl = this.$route.query.backUrl
      const path = backUrl || `/mobile-web-more-jobs/${this.company.id}/`
      const routeQuery = _.omit(this.$route.query, 'backUrl')
      this.$router.push({ path: path, query: routeQuery, hash: this.$route.hash })
    },
    onSurveyEntranceClick () {
      if (this.hasLogin && !this.personalAgreementStatus) {
        return
      }
      if (this.surveyInfo.survey?.has_answered) {
        if (this.job.root_company_id === ROOT_COMPANY_ID.MSD) {
          this.$router.push('/msdchina/join-talent-community')
        } else {
          this.$router.push(`/recruiting/company/${this.company.id}/survey`)
        }
      } else {
        this.showJobAlertDialog = true
      }
    },
    async renderMarker (item) {
      if (!this.mapObj || !item || !item.lng | !item.lat) {
        return
      }
      this.mapObj.clearMap()
      const AMap = await this.mapLoader
      this.mapObj.setCenter(new AMap.LngLat(item.lng, item.lat))
      const marker = new AMap.Marker({
        position: new AMap.LngLat(item.lng, item.lat),
        icon: new AMap.Icon({
          image: '/static/image/wechat/marker.png',
          size: new AMap.Size(29, 30)
        })
      })
      let markerTemplate
      if (item.index >= 1) {
        markerTemplate = `<div class="marker-icon">
                            <div class="job-count-marker">
                              <div >${item.index}</div>
                            </div>
                          </div>`
      } else {
        markerTemplate = `<div class="marker-icon">
                            <div class="job-count-marker"></div>
                          </div>`
      }
      marker.setContent(markerTemplate)
      marker.setMap(this.mapObj)
    },
    loccationClick (event, loc, index) {
      const locObj = { lng: '', lat: '', index: '' }
      locObj.lng = loc.longitude
      locObj.lat = loc.latitude
      locObj.index = index
      this.renderMarker(locObj)
      const list = this.$refs.mapjobLocations.querySelectorAll('li')
      if (list) {
        list.forEach(item => {
          item.classList.remove('selected-item')
        })
        const selectedItem = event.currentTarget
        if (!selectedItem) {
          event.classList.add('selected-item')
        } else {
          selectedItem.classList.add('selected-item')
        }
      }
    },
    setSelectedItem () {
      const item = this.$refs.mapjobLocations.querySelectorAll('li')
      if (item.length > 0) {
        this.loccationClick(item[0], this.jobLocationList[0], 1)
      }
    },
    // async checkStarbucksSSO () {
    //   if (!this.isInJoywok) {
    //     return
    //   }
    //   let jw = window.jw
    //   if (!jw) {
    //     await require('https://www.joywok.com/public/scripts/jssdk.js')
    //     jw = window.jw
    //   }
    //   let resp = null
    //   const url = window.location.origin + this.$route.path
    //   const params = {
    //     backurl: url
    //   }
    //   if (!(this.account && this.account.id)) {
    //     resp = await this.checkAutoLogin({ params })
    //   } else {
    //     resp = await this.getJoywokConfigParams({ params })
    //   }

    //   try {
    //     jw.ready = () => {
    //       if (!(this.account && this.account.id)) {
    //         jw.getAuthCode({
    //           url: url
    //         }, {
    //           success: async (data) => {
    //             await this.getEmployeeInfo({ code: data.code, params })
    //             this.$parent.routerAlive = false
    //             this.getSessionAccountInfo().then(res => {
    //               this.$parent.routerAlive = true
    //             })
    //           }
    //         })
    //       }

    //       jw.setFuncBtns([
    //         {
    //           type: 2
    //         }
    //       ])
    //     }
    //     window.onJwNavBtnClick = async (data) => {
    //       jw.shareURL({
    //         url: this.wxShareInfo.normal_share_url || window.location.href,
    //         title: this.wxShareInfo.title.replace('&#39;', "'"),
    //         cover: window.location.origin + this.wxShareInfo.logo
    //       }, {
    //         success: function (ret) {}
    //       })
    //     }

    //     const config = {
    //       debug: true,
    //       appid: resp.appid,
    //       corpid: resp.corpid,
    //       signature: resp.signature,
    //       timestamp: resp.timestamp,
    //       nonceStr: resp.nonceStr,
    //       app_access_token: resp.app_access_token,
    //       secretSignature: resp.secret_signature
    //     }
    //     jw.config(config)
    //   } catch (err) {}
    // },
    handleReferralRewardConfirm (event, hasSubmit) {
      const params = ['from_job=1', `company_id=${this.job.root_company_id}`, `back_url=${encodeURIComponent(this.$route.fullPath)}`]
      if (hasSubmit) {
        params.push('submit=1')
      }
      window.location.href = this.$DjangoBaseUrl(`/referral/employee-register/?${params.join('&')}`)
    },
    formatBigAmount (amount) {
      return _.replace(amount, /\d{1,3}(?=(\d{3})+$)/g, function (s) { return s + ',' })
    },
    onVideoNavigationShowChange (value) {
      this.hiddenChatbot = value
      this.referralIconShow = !value
    },
    formatTime (time) {
      if (!time) {
        return ''
      }
      return moment(time).format('YYYY-MM-DD')
    },
    getJobExperience (experience) {
      if (experience === '-1') {
        return this.$t(`${this.i18nPrefix}.label.experienceUnlimited`)
      }
      return this.$t(`${this.i18nPrefix}.label.experienceLabel`, { experience })
    }
  },
  watch: {
    languageCode () {
      this.getCustomizedParse()
    },
    // 禁止弹窗弹出后底层body滑动
    posterTransitionShow: {
      handler (newVal, oldVal) {
        if (newVal) {
          const scrollTop = document.body.scrollTop || document.documentElement.scrollTop
          document.body.style.cssText += 'position:fixed;width:100%;top:-' + scrollTop + 'px;'
        } else {
          const body = document.body
          body.style.position = ''
          const top = body.style.top
          document.body.scrollTop = document.documentElement.scrollTop = -parseInt(top)
          body.style.top = ''
        }
      }
    },
    // 禁止分享弹窗弹出后底层body滑动 同时保持弹框显示在屏幕中央
    referralTransitionShow (newVal, oldVal) {
      if (newVal) {
        document.scrollingElement.style.overflow = 'hidden'
      } else {
        document.scrollingElement.style.overflow = null
      }
    },
    showStatement () {
      this.hiddenChatbot = this.showStatement
    }
  },
  destroyed () {
    clearTimeout(this.addPotentialTimer)
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/animate.min.css';
@import '~@/assets/icomoon/style.css';
@import '~@/assets/scss/shake.scss';

#main {
  .agree {
    .company-policy-content {
      white-space: pre-wrap;
      word-break: break-word;
    }

    .company-policy-checkbox {
      display: flex;
      align-items: flex-start;
      white-space: pre-wrap;

      ::v-deep {
        .el-checkbox__input {
          flex: 0 0 auto;
          margin-top: 2px;
        }

        .el-checkbox__label {
          flex: 1;
          white-space: pre-wrap;
          word-break: break-word;
        }
      }
    }

    #tos_check_error {
      display: block;
    }
  }
  #referral-submit-info {
    position: fixed;
    bottom: 0;
    color: #fff;
    width: 100%;
    z-index: 99999;
    display: block;
    background: #fc8434;
    .pop-tip-bottom-inner {
      line-height: 20px;
      .btn-inner {
        .hidden-submit {
          background-image: unset;
          background: #fff;
          border-radius: 30px;
          width: 200px;
        }
      }

      .close {
        display: inline-block;
        position: absolute;
        top: 0;
        right: 0;
        font-size: 25px;
        width: 26px;
        height: 26px;
        text-align: center;
      }
    }
  }

  .company-custom {
    background: var(--custom-color) !important;
  }
  #referral-share-confirm {
    .confirm-message-div.jd-or-width {
      width: initial
    }
  }
  #referral-rewards-info {
    display: block;
  }

  #referral-icon {
    .referral-img {
      width: 65px;
    }
  }

  .job-detail-info {
    ::v-deep {
      .policy-form {
        padding: 0;
      }
    }
  }
}
.job-detail-info {
  .preview-mask {
    z-index: 123456789;
    position: absolute;
    width: 375px;
  }

  .palette-button {
    top: 88px;
    left: 50%;
    position: fixed;
    transform: translate(250px, 0);
  }

  .custom-header {
    &.is-preview {
      pointer-events: none;
    }

    .header-main {
      display: flex;
      height: auto;
      .logo {
        float: none;
      }
      .message {
        float: none;
        max-width: none;
        flex: 1;
        overflow: hidden;

        .job-name {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          white-space: initial;
        }
      }
    }

    .header-menu {
      .col-2, .col-3 {
        display: flex;
        flex-direction: column;
        justify-content: center;

        &.full-line {
          width: 100%;
        }
      }
    }
  }
  #job-detail-information-contanier {
    .job-intro {
      span {
        display: inline-block;
      }
      .all-locations {
        right: 0;
      }

      .job-field {
        .field-item {
          display: flex;
          align-items: center;

          .label {
            flex-shrink: 0;
            font-size: 14px;
            width: 100px;
          }
        }
      }
    }
    .job_location {
      .job-location-field {
        word-break: normal;
        overflow-wrap: normal;
      }

      .location {
        font-size: 22px;
        color: #666;
        position: absolute;
        top: 0;
        right: 0;
      }

      .label {
        font-size: 14px;
        width: 100px
      }
    }
  }
  .pop-tip-bottom {
    .referral-tip-message {
      font-size: 12px;
      margin-top: 20px;
    }
  }
  .company-survey-container {
    position: relative;
    .company-survey-entrance {
      position: absolute;
      font-size: 20px;
      top: 0;
      right: 0;
      span {
        font-size: 20px;
      }
      .iconcandidatesurvey-24 {
        color: var(--custom-color);
      }
    }
  }
  .no-job-custom-field {
    height: 24px;
  }
  .jd-submit-padding {
    padding-top:3px
  }
  .jd-submit-margin-top {
    margin-top: -4px;
  }
  .share-link-container {
    .share-link-btn {
      margin-left:30%
    }
  }
  .jd-map-container {
    position: fixed;
    bottom: 0;
    top:0;
    z-index: 100;
    width: 100%;
  }
  .no-custom-landing-page-navbar {
    .navbar {
      z-index: 2000;
    }
  }
  .powered-by {
    padding-bottom: 80px;
  }
  #wechat-popup {
    padding: 1px;
    #mask {
      display: block;
    }
    #referral-transition {
      display: block;
      transform: translate(-50%, -50%);
      position: fixed;
      top: 50vh;
      top: 50dvh;
      left: 50%;
      .share-job-poster {
        border: 0;
        padding-bottom: 8%;
        .poster-tip-container {
          display: flex;
          padding: 10px 15px;
          box-sizing: border-box;
          justify-content: space-between;
        }
        .poster-preview {
          width: 100%;
          overflow: hidden;
          display: flex;
          justify-content: space-around;
          align-items: center;
          padding: 0 10px;
          box-sizing: border-box;
          height: 190px;
          &-container {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            height: 100%;
            .image-container {
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 8px;
              // border: solid 1px #DCDCDC;
              // padding: 10px;
              box-sizing: border-box;
              height: 150px;
              .image-wrapper {
                height: 100%;
                position: relative;
                display: flex;
                .image-overlay {
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  z-index: 1;
                }
                img {
                  max-height: 100%;
                  max-width: 100%;
                  border-radius: 8px;
                  object-fit: contain;
                }
              }
              .icon-video-play {
                width: 35px;
                height: 35px;
                position: absolute;
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 1;
                > div {
                  width: 100%;
                  height: 100%;
                  border-radius: 50%;
                  background: rgba($color: #000000, $alpha: 0.6);
                }
                img {
                  position: absolute;
                  width: 100%;
                }
              }
            }
            .share-btn {
              width: 60px;
              height: 20px;
              border-radius: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 12px;
              color: white;
            }
            .save-video-tip {
              height: 30px;
              padding-top: 10px;
              font-size: 12px;
              display: flex;
              justify-content: center;
              align-items: center;
              text-align: center;
            }
          }
        }
      }
      .refer-share-to {
        padding-bottom: 0;
      }
      .share-content {
        padding-bottom: 5px;
        .get-rewards {
          text-align: center;
          margin-bottom: 7px;
          .get-rewards-btn {
            height: 28px;
            padding: 0 28px;
            border-radius: 999px;
            border-color: var(--custom-color);
            color: #fff;
            background-color: var(--custom-color);
          }
        }
      }

    }
    #wechat-pointer {
     display: block;
     left: -28px;
    }
    #qrcode-transition {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: block;
      .qrcode-content {
        display: block;
      }
    }
    #single-job-group-popup {
      display: block;
    }
    #transition {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: block;
    }
    #wechat-share-tip {
      display: block;
      right: 74px;
    }
    .poster-transition {
      position: fixed;
      z-index: 10001;
      width: 100%;
      height: 100%;
      top: 0px;
      overflow: scroll;
      .poster-img {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        z-index: 10001;
        img {
          -webkit-touch-callout: default;
        }
        video {
          width: 100%;
        }
        padding-top: 5vw;
        padding-top: 5dvw;
        max-height: 68%;
        overflow: scroll;
        position: relative;
      }
      .poster-close-btn {
        z-index: 10002;
        background: none;
        position: absolute;
        right: 1%;
        top: 1%;
        color: white;
        i {
          width: 32px;
          height: 32px;
          display: block;
          font-size: 220%;
        }
      }
      img {
        width: 100%;
      }
      .save-video-tip-pop {
        margin: 50px auto;
        margin-top: 20px;
        color: white;
        width: 90vw;
        width: 90dvw;
        text-align: center;
        padding-bottom: 38%;
        .generate-video-loading {
          width: 100%;
          height: 50px;
          position: relative;
          z-index: inherit;
        }
        .save-video-text {
          font-size: large;
          line-height: 22px;
        }
        .download-text {
          // margin-top: 30px;
          font-size: large;
          color: white;
          > span {
            margin-left: 7px;
            font-size: large;
            font-weight: bold;
          }
        }
        .download-image {
          width: 40vw;
          width: 40dvw;
          margin: 20px auto;
          span {
            font-size: 100px;
          }
        }
      }
      .wechat-download-tip {
        position: absolute;
        top: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100vw;
        width: 100dvw;
        height: 100vh;
        height: 100dvh;
        left: 0;
        overflow: scroll;
        background: rgba($color: #000000, $alpha: 0.75);
        img {
          width: 100%;
        }
        .got-it-container {
          position: relative;
          left: 15vw;
          left: 15dvw;
          width: 80px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .got-it-text {
            position: absolute;
            color: white;
            margin: 0;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }

      .job-poster-content {
        width: 90%;
      }

      .upload-new-poster {
        position: absolute;
        bottom: 16px;
        right: 32px;
        display: inline-block;
        vertical-align: middle;
        background-color: #000;
        opacity: 0.8;
        padding: 10px 14px;
        border-radius: 20px;
        color: #fff;
        .upload-btn {
          display: inline-block;
          vertical-align: middle;
          font-size: 16px;
        }
        .label {
          display: inline-block;
          vertical-align: middle;
          font-size: 16px;
        }
      }
    }
    .save-img-tip {
      box-sizing: border-box;
      padding: 25px;
      color: white;
      text-align: center;
      width: 80%;
      position: fixed;
      left: 10%;
      z-index: 10002;
      > span {
        font-size: large;
        line-height: 22px;
      }
    }
    .bottom-poster-list-content::-webkit-scrollbar {
      display: none;
    }
    .bottom-poster-list {
      box-sizing: border-box;
      padding: 15px 20px 10px 20px;
      width: 100%;
      background: white;
      border-radius: 8px 8px 0 0;
      position: fixed;
      bottom: 0;
      left: 0;
      ::v-deep {
        .van-tabs {
          height: 20vh;
          height: 20dvh;
          .van-tab--active {
            color: var(--custom-color)
          }
          .van-tabs__wrap {
            height: 32px;
            .van-tab__text {
              display: block;
              word-break: break-word;
              white-space: normal;
              text-align: center;
            }
          }

          .van-tabs__content {
            height: 68%;
            margin-top: 20px;

            .van-tab__pane-wrapper {
              height: 100%;
              .van-tab__pane {
                height: 100%;
              }
            }
          }
        }
      }
      .bottom-poster-list-content {
        width: 100%;
        height: 100%;
        overflow-x: scroll;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        > :not(:last-child) {
          margin-right: 15px;
        }
        > div {
          position: relative;
          flex-shrink: 0;
          background-repeat: no-repeat !important;
          background-size: cover !important;
          border-radius: 10px;
          width: calc((15vh - 40px) * 314 / 198);
          width: calc((15dvh - 40px) * 314 / 198);
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          .poster-item {
            position: relative;
            height: 100%;
            width: 100%;
            > span {
              position: absolute;
              font-size: 28px;
              color: white;
              border-radius: 50%;
              border: solid 2px white;
              display: block;
              width: 42px;
              height: 42px;
              display: flex;
              justify-content: center;
              align-items: center;
              z-index: 100;
              top: 30%;
              left: 33%;
            }

            .delete-poster {
              display: flex;
              background-color: #666666;
              font-size: 12px;
              position: absolute;
              right: 0;
              top: 0;
              width: 20px;
              height: 20px;
              border-bottom-left-radius: 10px;
              border-top-right-radius: 10px;
              color: #fff;
              align-items: center;
              justify-content: center;
            }
            .icon-video-play {
              width: 36px;
              height: 36px;
              position: absolute;
              display: flex;
              justify-content: center;
              align-items: center;
              top: 34%;
              left: 37%;
              > div {
                width: 100%;
                height: 100%;
                border-radius: 50%;
                background: rgba($color: #000000, $alpha: 0.6);
              }
              img {
                position: absolute;
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
  #referral-icon {
    z-index: 150;
  }

  .loading-apply-status {
    .rect-loading {
      position: absolute;
    }
  }
  .view-rules-popup {
    .full-image {
      height: 90% !important;
      .main {
        margin-top: 10%;
      }
    }
    .close-btn {
      color: var(--custom-color) !important;
    }

    .custom-image-popDiv {
      z-index: 2147483647
    }

    .custom-image-popbox {
      padding: 0;
      background: unset;
    }

    .custom-image-icon {
      font-size: 30px;
      color: #fff;
      display: block;
      text-align: center;
      margin: 24px;
    }
  }

  .chatbot {
    ::v-deep #btnDialogToggle {
      width: 60px;
      height: 60px;
    }
  }

  .video-navigation-wrapper {
    &.preview {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      transform: translate(0, 0);
      overflow: hidden;
      pointer-events: none;

      ::v-deep .video-navigation-container {
        .video-swiper {
          .video-list {
            .video-item {
              .clickable-mask {
                .video-progress {
                  .video-progress-bar {
                    .el-slider__runway {
                      .el-slider__button-wrapper {
                        top: -16px;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .video-navigation {
    bottom: 128px;
    margin-right: 95px;
    z-index: 101;

    ::v-deep .expend-icon {
      bottom: 165px;
    }
  }
}

</style>
